export const MOCK_HOTELS = [
  {
    __typename: "FdrHotel",
    publicId: "h-463817",
    giataCode: 463817,
    name: "Comfort Hotel Karl Johan",
    rating: 3.0,
    tripAdvisorCode: 0,
    coordinates: {
      latitude: 59.9118089,
      longitude: 10.746124799999961,
    },
    mapZoom: 14,
    mythosInfo: null,
    leadText:
      "<p>Das Dreisternehotel an der bekannten Einkaufsstrasse beeindruckt mit seinem stilvollen und individuellen Design. Mit gutem Preis-Leistungs-Verhältnis ideal für Ihre Städtereise nach Oslo.</p>",
    textInfo: {
      situation:
        "<p>Direkt an der pulsierenden Einkaufsmeile Karl Johan Gate mit zahlreichen Geschäften und Boutiquen. Rund um das Hotel befindet sich eine Vielzahl an Restaurants und Bars. Die Domkirche aus dem 17. Jahrhundert finden Sie gegenüber dem Hotel. Das architektonisch interessante Opernhaus erreichen Sie nach etwa 800 m. Das Königliche Schloss und der malerische Schlosspark sind rund 1,2 km entfernt. Zum Hauptbahnhof gelangen Sie nach ca. 300 m. Bis zur Tramhaltestelle Stortorvet sind es knapp 100 m.</p>",
      facilityFeatures:
        "<p>Das Comfort Hotel Karl Johan ist in einem restaurierten Gebäude untergebracht. Zur stilvollen Einrichtung gehören ein einladender Empfangsbereich mit Réception und WLAN (gratis). Zu den gastronomischen Angeboten zählen ein Burgerrestaurant und eine Bar.</p>",
      accommodationFeatures:
        "<p>Die geschmackvoll und individuell eingerichteten <b>Zimmer </b>(15–20 m<sup>2</sup>) verfügen über Dusche, WC, Föhn; Telefon, TV, WLAN (gratis). Die<b> Superior-Zimmer</b> (20–30 m<sup>2</sup>) sind bei gleicher Grundausstattung geräumiger. Die <b>Deluxe-Zimmer</b> (ca. 35 m<sup>2</sup>) bieten zusätzlich einen integrierten Wohn-/Schlafbereich mit Bettsofa.</p>",
      rooms: "260",
      sportFree: "<p>Fitnessraum.</p>",
      sportPaid: "",
      activities: "",
      forKids: "",
      catering: "<p>Frühstück.</p>",
      hints:
        "<p>Die Bezahlung im Hotel erfolgt ausschliesslich bargeldlos.</p>",
      infoPlus: "",
      familyHits: "",
      skiPackages: "",
      wellnessPlus: "",
      hotelWellnessInfo: "",
      hotelWellnessPaket: "",
      moreInformation: "",
      officialRating: "<p>***</p>",
      highlights: "",
    },
    flags: {
      top: false,
      bestseller: false,
      cityTrip: true,
      winterSport: false,
      summerSport: false,
      nightLife: false,
      gourmet: false,
      club: false,
      luxury: false,
      pets: false,
      sustainable: false,
      romantic: false,
      gayLesbians: false,
      ski: false,
      funPark: false,
      nationalPark: false,
      adultsOnly: false,
      refundable: false,
      extraOrdinary: false,
      wifi: {
        achieved: true,
        inRoomFreeWifi: true,
        inRoomPaidWifi: false,
        inLobbyFreeWifi: true,
        inLobbyPaidWifi: false,
      },
      beach: {
        achieved: false,
        sandyBeach: false,
        sandyBeachWhiteFine: false,
        cobbleStone: false,
        rocksStones: false,
        naturalBeach: false,
        gentlySloping: false,
        privateBeach: false,
        reefBeach: false,
      },
      foodAndBeverage: {
        buffet: false,
        alaCarteRestaurants: true,
        gourmetRestaurant: false,
        beachBar: false,
        bar: true,
        snackBarBistro: false,
        roomService: false,
      },
      entertainment: {
        achieved: false,
        discoNightclub: false,
        animation: false,
        show: false,
      },
      beautyAndWellness: {
        achieved: false,
        sauna: false,
        steamBathHamam: false,
        spaHealthCenter: false,
        massage: false,
        ayurveda: false,
        beautyTreatment: false,
        yoga: false,
      },
      waterSport: {
        achieved: false,
        diveCenter: false,
        canoeKayak: false,
        sailingCatamaran: false,
        waterSkiWakeboarding: false,
        surfing: false,
        windSurfing: false,
        kiteSurfing: false,
        outdoorPool: false,
        indoorPool: false,
      },
      sport: {
        achieved: false,
        gym: true,
        soccer: false,
        beachSport: false,
        tennis: false,
        golfDrivingRange: false,
        cycling: false,
        sportProgram: false,
        squash: false,
        skiPackageAvailable: false,
      },
      location: {
        beachFront: false,
        distanceToBeach500M: false,
        directlyAtSlopeValleyStation: false,
        distanceToSlopeValleyStation300M: false,
        cityCenter: true,
        ruralArea: false,
        remoteArea: false,
        directlyAtSea: false,
        nationalPark: false,
        airportHotel: false,
        directlyAtLake: false,
      },
      family: {
        achieved: false,
        babysittingService: false,
        childCare: false,
        miniOrChildrenClub: false,
        teenProgram: false,
        childPool: false,
        childrenPlayground: false,
        waterSlide: false,
      },
      customerSegment: {
        honeymooner: false,
        singles: false,
        couples: false,
        gayLesbians: false,
        adultsOnly: false,
      },
      typeFlags: {
        rooms50: false,
        rooms100: false,
        rooms200: false,
        rooms500: true,
        rooms999: false,
        modernDesign: false,
        luxury: false,
        charm: false,
        funPark: false,
        familyAtmosphere: false,
        club: false,
        wheelchairAccess: false,
        sustainable: false,
        petsWelcome: false,
        parking: false,
        apartment: false,
        chargingStations: false,
      },
    },
    hero: {
      url: "https://assets.hotelplan.com/myassets/webimages/765/765389.jpg",
    },
    images: [
      {
        url: "https://assets.hotelplan.com/myassets/webimages/765/765389.jpg",
      },
      {
        url: "https://assets.hotelplan.com/myassets/webimages/765/765395.jpg",
      },
      {
        url: "https://assets.hotelplan.com/myassets/webimages/765/765386.jpg",
      },
      {
        url: "https://assets.hotelplan.com/myassets/webimages/765/765385.jpg",
      },
      {
        url: "https://assets.hotelplan.com/myassets/webimages/765/765391.jpg",
      },
      {
        url: "https://assets.hotelplan.com/myassets/webimages/765/765377.jpg",
      },
      {
        url: "https://assets.hotelplan.com/myassets/webimages/765/765383.jpg",
      },
      {
        url: "https://assets.hotelplan.com/myassets/webimages/765/765387.jpg",
      },
      {
        url: "https://assets.hotelplan.com/myassets/webimages/765/765379.jpg",
      },
      {
        url: "https://assets.hotelplan.com/myassets/webimages/765/765376.jpg",
      },
      {
        url: "https://assets.hotelplan.com/myassets/webimages/765/765381.jpg",
      },
      {
        url: "https://assets.hotelplan.com/myassets/webimages/765/765374.jpg",
      },
    ],
  },
  {
    "__typename" : "FdrHotel",
    "publicId" : "h-76123",
    "giataCode" : 76123,
    "name" : "Scandic Victoria",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.91257143331877,
      "longitude" : 10.73700965149332
    },
    "mapZoom" : 15,
    "mythosInfo" : null,
    "leadText" : "<p>Das Viersternehotel der beliebten Scandic-Kette punktet an zentraler Lage mit seinem stilvollen Interieur und ist der perfekte Ausgangspunkt für Ihre Städtereise nach Oslo.</p>",
    "textInfo" : {
      "situation" : "<p>An äusserst zentraler Lage ist das Hotel umgeben von verschiedenen Restaurants, Bars und Geschäften. Das Rathaus, das Nationaltheater und die beliebte Einkaufsstrasse Karl Johans Gate erreichen Sie nach etwa 250 m. Die Festung Akershus sowie die Domkirche sind ca. 650 m und das Königliche Schloss rund 750 m entfernt. Das pulsierende Viertel Aker Brygge erreichen Sie nach ca. 800 m. Der Hauptbahnhof ist rund 1 km entfernt. Bis zur Tramhaltestelle Kontraskjaeret sind es etwa 200 m und bis zur U-Bahnstation Stortinget knapp 300 m.</p>",
      "facilityFeatures" : "<p>Das Scandic Victoria besticht durch sein stilvolles und modernes Interieur. Zur Einrichtung gehören ein einladender Empfangsbereich mit Réception und WLAN (gratis). Zudem bietet das Hotel einen Frühstücksraum und eine Selbstbedienungsbar. Garage gegen Gebühr.</p>",
      "accommodationFeatures" : "<p>Die stilvoll eingerichteten <b>Zimmer</b> (18–25 m<sup>2</sup>) verfügen über Bad oder Dusche, WC, Föhn; Telefon, TV, WLAN (gratis), Minikühlschrank, Tee-/Kaffeekocher. Die <b>Superior-Zimmer</b> (20–30 m<sup>2</sup>) sind bei gleicher Grundausstattung geräumiger und haben eine Sitzecke. Die<b> Suiten</b> (40–50 m<sup>2</sup>) bestehen aus 1 Schlafzimmer und 1 Wohnzimmer.</p>",
      "rooms" : "199",
      "sportFree" : "<p>Fitnessraum.</p>",
      "sportPaid" : "<p>Fahrradverleih.</p>",
      "activities" : "",
      "forKids" : "",
      "catering" : "<p>Frühstück.</p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : false,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : false,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : true,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765327.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765327.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765316.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765310.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765338.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765326.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765314.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765324.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765311.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765329.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765344.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765335.jpg"
    } ]
  },{
    "__typename" : "FdrHotel",
    "publicId" : "h-21194",
    "giataCode" : 21194,
    "name" : "Scandic Byporten",
    "rating" : 3.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.91170899999999,
      "longitude" : 10.752018899999939
    },
    "mapZoom" : 17,
    "mythosInfo" : null,
    "leadText" : "<p>Das Mittelklassehotel bietet eine der zentralsten Lagen in Oslo und befindet sich im gleichen Gebäude wie das Einkaufszentrum Byporten. Ein ideales Hotel, um die Stadt zu Fuss zu erkunden.</p>",
    "textInfo" : {
      "situation" : "<p>Direkt beim Hauptbahnhof von Oslo gelegen. Die Karl Johans Gate, der Stadtbezirk Grunerlokka und die Oper sind bequem zu Fuss erreichbar.</p>",
      "facilityFeatures" : "<p>Geräumige und moderne Lobby, wo auch kleine Mahlzeiten, Snacks, erfrischende Getränke und Kaffee bezogen werden können. WLAN (gratis).</p>",
      "accommodationFeatures" : "<p>Die 239 Zimmer sind im skandinavischen Stil eingerichtet. Die eher kleinen, aber praktisch eingerichteten Doppelzimmer Standard bieten Dusche, WC, Föhn, Bügeleisen und -brett. Die Standard-Plus-Zimmer bieten zusätzlich Meersicht. Familienzimmer sind verfügbar.</p>",
      "rooms" : "239",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "",
      "highlights" : ""
    },
    "flags" : {
      "top" : true,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : false,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : false,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/397/397789.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/397/397789.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/397/397785.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/397/397786.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/397/397787.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/397/397788.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/397/397790.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/397/397791.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/397/397792.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/397/397784.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-298019",
    "giataCode" : 298019,
    "name" : "The Thief",
    "rating" : 5.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.907528604435726,
      "longitude" : 10.720471952009575
    },
    "mapZoom" : 19,
    "mythosInfo" : null,
    "leadText" : "<p>Neues Desginhotel an exklusiver Lage, in welchem man sich nach einem strengen Tag gut erholen kann.</p>",
    "textInfo" : {
      "situation" : "<p>Das The Thief liegt im Viertel Tjuvlholmen in Oslo. Die lebhafte Promenade von Aker Brygge erreichen Sie in 5 Gehminuten. Die nächste Bushaltestelle ist ca. 400 m entfernt.</p>",
      "facilityFeatures" : "<p>Geniessen Sie norwegisch inspirierte Küche im Restaurant Fru K oder in der Thief-Food-Bar. Entspannen Sie sich auf der Dachterrasse, in der Sauna, im Dampfbad oder im kleinen Pool. Im Haus befinden sich auch ein Coiffeur und ein Make-up-Stylist. Gratis-WLAN.</p>",
      "accommodationFeatures" : "<p>Die stilvollen Zimmer haben ein eingebautes Soundsystem und eine Kaffeemaschine. Alle Zimmer verfügen über einen Balkon, Bad mit Regendusche, WC, TV und Minibar.</p>",
      "rooms" : "119",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "<p>Als Gast des Hotels geniessen Sie Gratis-Eintritt im Museum für moderne Kunst Astrup Fearnley.</p>",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : true,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : true,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : true,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : true,
        "luxury" : true,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108683.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108683.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108689.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108687.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108695.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108696.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108686.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108685.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108682.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108684.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-32754",
    "giataCode" : 32754,
    "name" : "Thon Opera",
    "rating" : 3.5,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.909261898274536,
      "longitude" : 10.752969596434014
    },
    "mapZoom" : 16,
    "mythosInfo" : null,
    "leadText" : "<p>Das moderne Hotel der gehobenen Mittelklasse empfängt die Gäste in einer grosszügigen Lobby und legt grossen Wert auf einen aufmerksamen Service.</p>",
    "textInfo" : {
      "situation" : "<p>Direkt neben dem Bahnhof mit dem Terminal des Flughafen-Expresszuges gelegen. In unmittelbarer Nähe befindet sich die Karl Johan Gate, Oslos betriebsame Einkaufsstrasse.</p>",
      "facilityFeatures" : "<p>Restaurant Scala mit A-la-carte-Gerichten und Bar mit Kleinigkeiten für zwischendurch. Fitnessraum und Sauna. WLAN (gratis), Parkplatz (gegen Gebühr).</p>",
      "accommodationFeatures" : "<p>480 freundliche, im klassischen Stil eingerichtete Zimmer mit Bad oder Dusche, WC, Föhn, Flachbildschirm-TV, Telefon und Minibar.</p>",
      "rooms" : "480",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : true,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/316/316462.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/316/316462.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/316/316464.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/566/566160.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/566/566166.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/566/566157.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/566/566158.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-29337",
    "giataCode" : 29337,
    "name" : "Clarion Hotel The Hub",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.91261047156873,
      "longitude" : 10.750740858370591
    },
    "mapZoom" : 20,
    "mythosInfo" : null,
    "leadText" : "<p>Dieses im März 2019 eröffnete Hotel an ideal gelegener Lage, bietet ein modernes und komfortables Ambiente.</p>",
    "textInfo" : {
      "situation" : "<p>Der Hauptbahnhof und die bekannte Karl-Johans-Strasse befinden sich nur gut 100 m entfernt. Viele Sehenswürdigkeiten können in kaum 15 Gehminuten erreicht werden.</p>",
      "facilityFeatures" : "<p>Drei verschiedene Restaurants und Bars sowie ein Fitnessraum und eine Wellnessabteilung mit einem kleinen Pool komplettieren die Vielfalt dieses Hotels. Auf dem Dach wird ein eigener Garten angelegt, um in den Restaurants frische Zutaten zu servieren. Gratis-WLAN. Parplätze gegen Gebühr.</p>",
      "accommodationFeatures" : "<p>Die Zimmer sind innovativ und modern eingerichtet und in unterschiedlichen Grössen und Ausstattungen verfügbar. Das Badezimmer bietet Dusche, WC und Föhn.</p>",
      "rooms" : "810",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : true,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : true,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : true,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : false,
        "rooms999" : true,
        "modernDesign" : true,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : true,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/466/466307.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/466/466307.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/466/466309.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/466/466310.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/466/466306.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/466/466308.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-244195",
    "giataCode" : 244195,
    "name" : "Scandic Vulkan",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.922268957816414,
      "longitude" : 10.750962500000014
    },
    "mapZoom" : 17,
    "mythosInfo" : null,
    "leadText" : "<p>Stilvolles und modernes Hotel mit viel Design, an ausgezeichneter Lage in Oslo, direkt neben der berühmten Markthalle.</p>",
    "textInfo" : {
      "situation" : "<p>Im attraktiven und dynamischen Stadtteil Vulkan gelegen, neben der berühmten Markthalle. Bis zur Innenstadt von Oslo mit zahlreichen Geschäften, Restaurants, Bars, Cafés sowie Sehenswürdigkeiten ist es nur rund 1 km. Anschluss an öffentliche Verkehrsmittel sind zu Fuss erreichbar. Zum Flughafen von Oslo sind es etwa 49 km. </p>",
      "facilityFeatures" : "<p>Empfangshalle mit Réception und WLAN (gratis). Restaurant mit italienischen Gerichten und gemütliche Bar, Minimarkt, Bibliothek. Parkplatz gegen Gebühr.</p>",
      "accommodationFeatures" : "<p>Alle Zimmer verfügen über Bad oder Dusche, WC, Föhn; Telefon, Sat.-TV, WLAN (gratis), Mietsafe und Klimaanlage.</p>",
      "rooms" : "149",
      "sportFree" : "<p>Fitnessraum.</p>",
      "sportPaid" : "<p>Fahrradverleih.</p>",
      "activities" : "",
      "forKids" : "",
      "catering" : "<p>Frühstücksbuffet.</p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : true,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : true,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : true,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : true,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/339/339463.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/339/339463.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/339/339462.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/339/339467.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/339/339465.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/339/339468.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/339/339464.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/339/339466.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-19802",
    "giataCode" : 19802,
    "name" : "Radisson Blu Plaza Oslo",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.91255351437755,
      "longitude" : 10.755868746032705
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Das moderne Viersternehotel punktet mit seinem atemberaubenden Panoramablick über die Stadt sowie den Fjord. An zentraler Lage die perfekte Adresse für Ihre Städtereise nach Oslo.</p>",
    "textInfo" : {
      "situation" : "<p>An zentraler Lage ist das Hotel nur knapp 200 m vom Hauptbahnhof Oslo entfernt. Zahlreiche Restaurants, Bars und verschiedene Geschäfte befinden sich rund um das Hotel. Bis zur Domkirche sind es etwa 500 m. Das spektakuläre und bekannte Opernhaus erreichen Sie nach ca. 900 m. Das königliche Schloss mit seinem wunderschönen Schlosspark ist rund 1,5 km entfernt. Bis zum Einkaufs- und Unterhaltungsviertel Aker Brygge sind es knapp 2 km.</p>",
      "facilityFeatures" : "<p>Das Radisson Blu Plaza Oslo ragt mit 37 Etagen in einem imposanten Gebäude mit Glasfassade in die Höhe. Zur modernen Einrichtung gehören ein grosszügiger Empfangsbereich mit Réception, WLAN (gratis) und Lobbybar. Zu den gastronomischen Angeboten zählen ein A-la-carte-Restaurant in der 34. Etage mit regionaler Küche und internationalem Touch sowie eine Bar mit fantastischem Panoramablick auf die Stadt.</p>",
      "accommodationFeatures" : "<p>Die stilvoll und mit Designelementen eingerichteten <b>Zimmer</b> (ca. 26 m<sup>2</sup>) verfügen über Dusche, WC, Föhn; Telefon, TV, WLAN (gratis), Gratissafe, Tee-/Kaffeekocher, Klimaanlage. Auch mit Blick auf den Fjord buchbar. Die <b>Suiten</b> (ca. 40 m<sup>2</sup>) sind bei gleicher Grundausstattung geräumiger und teilweise mit separatem Wohnbereich. Auch mit Blick auf den Fjord buchbar.</p>",
      "rooms" : "678",
      "sportFree" : "<p>Fitnessraum. <b>Wellness:</b> Hallenbad, Sauna.</p>",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "<p>Ohne Mahlzeiten. Auf Wunsch mit Frühstück buchbar.</p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : true
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : false,
        "rooms999" : true,
        "modernDesign" : true,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749642.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749642.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749607.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749632.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749688.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749625.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749647.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749609.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749697.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749627.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749677.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749605.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749689.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749621.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749685.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749674.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-296617",
    "giataCode" : 296617,
    "name" : "Comfort Hotel Grand Central",
    "rating" : 3.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.91057767830614,
      "longitude" : 10.751232101852425
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Dreisternehotel an der zentralsten Lage in Oslo. Neben dem Hauptbahnhof gelegen, punktet das Hotel mit seiner geschmackvollen Einrichtung voller Charme und ist perfekt für Ihre Städtereise.</p>",
    "textInfo" : {
      "situation" : "<p>Am Bahnhofsplatz in Oslo gelegen, ist das Hotel ein idealer Ausgangspunkt, um die zahlreichen Sehenswürdigkeiten der norwegischen Hauptstadt zu entdecken. Rund um das Hotel befinden sich verschiedene Restaurants und Bars. Vor dem Hotel beginnt die beliebte Einkaufsstrasse Karl Johans Gate mit diversen Geschäften und Boutiquen. Das einzigartige Opernhaus, welches mit seinem weissen Dach als Top-Fotomotiv gilt, erreichen Sie nach rund 400 m. Die Domkirche aus dem 17. Jahrhundert ist ebenfalls etwa 400 m entfernt. Entdecken Sie das neue Viertel Bjorvika mit dem modernen Munch-Museum (ca. 800 m), besichtigen Sie den malerischen Schlosspark und werfen Sie einen Blick auf das Königliche Schloss (ca. 1,5 km) oder flanieren Sie durch Aker Brygge (ca. 1,8 km).</p>",
      "facilityFeatures" : "<p>Das Comfort Hotel Grand Central ist im ehemaligen Bahnhofsgebäude aus dem Jahre 1854 untergebracht. Zur Einrichtung gehören ein einladender Empfangsbereich mit Réception, Lounge und WLAN (gratis). Zu den gastronomischen Angeboten zählt ein italienisches A-la-carte-Restaurant.</p>",
      "accommodationFeatures" : "<p>Die geschmackvoll und individuell eingerichteten <b>Zimmer</b> (15–20 m<sup>2</sup>) verfügen über Bad oder Dusche, WC, Föhn; Telefon, TV WLAN (gratis). Die <b>Superior-Zimmer </b>(20–28 m<sup>2</sup>) sind bei gleicher Grundausstattung grösser. Die geräumigen <b>Suiten</b> (28–38 m<sup>2</sup>) haben einen integrierten oder optisch abgetrennten Wohnbereich.</p>",
      "rooms" : "194",
      "sportFree" : "<p>Fitnessraum.</p>",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "<p>Frühstück.</p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>***</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : false,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765242.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765242.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765236.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765224.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765221.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765237.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765234.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765230.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765238.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765232.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765233.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765227.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765235.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765225.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765231.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-72340",
    "giataCode" : 72340,
    "name" : "Thon Hotel Munch",
    "rating" : 3.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.91707502,
      "longitude" : 10.74219034
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Mittelklassehotel in einer ruhigen Seitenstrasse, das sich ideal für die Erkundung der Stadt eignet.</p>",
    "textInfo" : {
      "situation" : "<p>Das Hotel befindet sich in einer ruhigen Seitenstrasse im Zentrum von Oslo. Restaurants, Bars, Einkaufsmöglichkeiten und öffentliche Verkehrsmittel finden Sie in der Nähe des Hotels. Der Bahnhof ist etwa 1 km und der Flughafen ca. 50 km entfernt.</p>",
      "facilityFeatures" : "<p>Das Hotel verfügt über einen Empfangsbereich mit Réception und WLAN (gratis). Frühstücksraum.</p>",
      "accommodationFeatures" : "<p>Alle Zimmer verfügen über Bad oder Dusche, WC, Föhn; Telefon, Sat.-TV, WLAN (gratis), Klimaanlage.</p>",
      "rooms" : "180",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "<p>Ohne Mahlzeiten.</p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>***</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : false,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : false,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/302/302155.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/302/302155.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/302/302160.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/302/302153.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/302/302163.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/302/302157.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/302/302154.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-36537",
    "giataCode" : 36537,
    "name" : "Thon Astoria",
    "rating" : 2.5,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.91107192481851,
      "longitude" : 10.746923897314446
    },
    "mapZoom" : 15,
    "mythosInfo" : null,
    "leadText" : "<p>Sympathisches Hotel der Touristenklasse mit freundlichem Service.</p>",
    "textInfo" : {
      "situation" : "<p>Sehr zentral gelegen. Ob Bahnhof, Einkaufsstrassen, Museen, Restaurants oder Bars, alles ist in wenigen Gehminuten erreichbar. Bietet somit die ideale Voraussetzung für einen kurzweiligen Städteaufenthalt in der norwegischen Hauptstadt.</p>",
      "facilityFeatures" : "<p>Im Restaurant wird ein skandinavisches Frühstücksbuffet serviert und in der Lobby steht den Gästen ein Computer mit Internetanschluss zur freien Benutzung zur Verfügung.</p>",
      "accommodationFeatures" : "<p>180 einfach, aber geschmackvoll eingerichtete Zimmermit Dusche, WC, Föhn, TV, Telefon und WLAN (gratis).</p>",
      "rooms" : "180",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>***</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : false,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : true,
        "alaCarteRestaurants" : false,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : false,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108660.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108660.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108663.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108662.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108664.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-47055",
    "giataCode" : 47055,
    "name" : "Grand Hotel Oslo by Scandic",
    "rating" : 5.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.9137029,
      "longitude" : 10.7394434
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Das wohl angesehenste Hotel Norwegens blickt auf eine traditionsreiche Vergangenheit zurück und überzeugt an bester Lage mit zuvorkommendem Service und luxuriösem Ambiente.</p>",
    "textInfo" : {
      "situation" : "<p>An privilegierter Lage direkt an der exklusiven Einkaufsstrasse Karl Johans gate und gegenüber des Parlaments gelegen. Das Nationaltheater erreichen Sie nach knapp 300 m. Den Schlosspark erreichen Sie nach etwa 600 m. Ebenfalls ca. 600 m entfernt sind das Rathaus und der Hafen. Das architektonisch sehr sehenswerte Opernhaus ist ca. 1,2 km entfernt. Zur nächsten U-Bahnstation Stortinget sind es knapp 150 m und zum Hauptbahnhof etwa 800 m.</p>",
      "facilityFeatures" : "<p>Das traditionsreiche und geschichtsträchtige Hotel öffnete seine Türen im Jahre 1874 und gilt als eines der bekanntesten und angesehensten Hotels Norwegens. Hier haben schon Persönlichkeiten wie Nobelpreisträger oder der bekannte norwegische Autor Henrik Ibsen übernachtet. Hinter der historischen Fassade verbirgt sich ein eleganter Empfangsbereich mit Réception, WLAN (gratis), Bibliothek und Lobbybar. Gediegenes A-la-carte-Restaurant mit vorzüglicher Küche (internationale Spezialitäten mit nordischem Touch), Bar auf der Dachterrasse mit herrlichem Panoramablick auf die Stadt. Garage gegen Gebühr.</p>",
      "accommodationFeatures" : "<p>Die eleganten, individuell eingerichteten Zimmer vereinen historisches und modernes Design gekonnt. Alle verfügen über Bad oder Dusche, WC, Föhn, Bademantel, Hausschuhe; Telefon, Sat.-TV, WLAN (gratis), Gratissafe, Minibar, Tee-/Kaffeekocher, Sitzecke, Klimaanlage. Zimmerservice. Die Suiten bieten zusätzlich zur Grundausstattung eine Nespressomaschine und sind geräumiger. Sie bestehen aus 1 Schlafzimmer und 1 separaten oder optisch abgetrennten Wohnbereich.</p>",
      "rooms" : "283",
      "sportFree" : "",
      "sportPaid" : "<p>Fitnessraum. <b>Wellness:</b> Spa-Bereich mit Innenpool, Sauna, Dampfbad sowie Massagen und Schönheitsbehandlungen.</p>",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>*****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : true,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : true,
        "sauna" : true,
        "steamBathHamam" : true,
        "spaHealthCenter" : true,
        "massage" : true,
        "ayurveda" : false,
        "beautyTreatment" : true,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : true
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : true,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/545/545308.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/545/545308.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/545/545316.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/545/545297.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/545/545303.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/545/545326.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/545/545330.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/545/545307.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/545/545301.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/545/545322.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/545/545314.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/545/545327.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/545/545312.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/545/545311.jpg"
    } ]
  },
  {
    "__typename" : "FdrHotel",
    "publicId" : "h-20328",
    "giataCode" : 20328,
    "name" : "Scandic Oslo City",
    "rating" : 3.5,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.91195942035093,
      "longitude" : 10.74929497008361
    },
    "mapZoom" : 15,
    "mythosInfo" : null,
    "leadText" : "<p>Dieses beliebte Mittelklassehotel zeichnet sich vor allem durch die ideale Lage aus.</p>",
    "textInfo" : {
      "situation" : "<p>Im Stadtzentrum von Oslo liegt das Hotel nur 100 m vom Hauptbahnhof und dem Expresszug zum Flughafen entfernt. Die Haupteinkaufsstrasse befindet sich gleich um die Ecke.</p>",
      "facilityFeatures" : "<p>Im Restaurant Bjørvigen Mat &amp; Vinhus geniessen Sie norwegische sowie internationale Gerichte à la carte. Die gemütliche Bar und die Sauna laden zum Entspannen ein. WLAN (gratis).</p>",
      "accommodationFeatures" : "<p>Die 175 eher kleinen, aber gemütlich eingerichteten Zimmer verfügen über Bad oder Dusche, WC, Telefon und Minibar.</p>",
      "rooms" : "175",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108701.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108701.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/510/510602.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/510/510597.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/510/510604.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/108/108700.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/510/510598.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/510/510603.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/510/510607.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/510/510612.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/510/510613.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-19837",
    "giataCode" : 19837,
    "name" : "Thon Hotel Europa",
    "rating" : 3.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.91792815499264,
      "longitude" : 10.734986186508195
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Komfortables Dreisternehotel im Herzen von Oslo.</p>",
    "textInfo" : {
      "situation" : "<p>Mitten im Zentrum von Oslo gelegen. Zahlreiche Einkaufs- und Unterhaltungsmöglichkeiten, Restaurants, Cafés, berühmte Sehenswürdigkeiten wie der Königspalast, Nationaltheater, Opernhaus, Aker Brygge und Akershus Fort sowie Anschluss an öffentliche Verkehrsmittel befinden sich in unmittelbarer Nähe. Zum Hauptbahnhof von Oslo sind es nur rund 300 m und bis zum Flughafen etwa 50 km. </p>",
      "facilityFeatures" : "<p>Für Ihren Komfort verfügt das Stadthotel auf 8 Etagen über Empfangshalle mit Réception (24 Stunden geöffnet), Geldwechselstube, Wäsche- und Bügelservice (gegen Gebühr), WLAN (gratis), Restaurant und Bar. </p>",
      "accommodationFeatures" : "<p>Alle Zimmer verfügen über Bad oder Dusche, WC, Föhn; Telefon, LCD-Sat.-TV, WLAN (gratis), Minibar, Tee-/Kaffeekocher, Mietsafe.</p>",
      "rooms" : "168",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "<p>Folgende Kreditkarten werden im Hotel akzeptiert: Euro/Mastercard und Visa. </p>",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>***</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : true,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/302/302164.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/302/302164.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/302/302166.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/302/302167.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/302/302165.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-69712",
    "giataCode" : 69712,
    "name" : "Clarion Collection Hotel Savoy",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.91667437207548,
      "longitude" : 10.738412449311507
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Im Herzen des pulsierenden Stadtzentrums besticht das Viersternehotel mit guter Küche und seiner Einrichtung im minimalistischen Design. Die perfekte Adresse für Ihre Städtereise nach Oslo.</p>",
    "textInfo" : {
      "situation" : "<p>Das Hotel an zentraler Lage ist umgeben von zahlreichen Restaurants und Bars sowie verschiedenen Geschäften. Den weitläufigen Schlosspark und das Königliche Schloss erreichen Sie nach etwa 600 m. Die belebte Hafenpromenade im beliebten Viertel Aker Brygge ist rund 1 km entfernt. Bis zum bekannten Opernhaus mit seinem einzigartigen Dach sind es ca. 1,5 km. Die U-Bahnstation Stortinget ist ca. 500 m entfernt. Den Hauptbahnhof erreichen Sie nach rund 1 km.</p>",
      "facilityFeatures" : "<p>Das Clarion Collection Hotel Savoy wurde 1925 eröffnet und hat seitdem auch einige Berühmtheiten beherbergt. Zur Einrichtung gehören ein Empfangsbereich mit Réception und WLAN (gratis). Zu den gastronomischen Angeboten zählen ein Gourmetrestaurant, ein Hotelrestaurant mit Tagesmenü und eine Bar.</p>",
      "accommodationFeatures" : "<p>Die komfortabel und in schlichtem Design eingerichteten <b>Zimmer </b>verfügen über Bad oder Dusche, WC, Föhn; Telefon, TV, WLAN (gratis), Minibar.</p>",
      "rooms" : "89",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "<p>Frühstück.</p>",
      "hints" : "<p>Die Bezahlung im Hotel erfolgt ausschliesslich bargeldlos.</p>",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : true,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : true,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : true,
        "rooms200" : false,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765517.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765517.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765508.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765499.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765516.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765503.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765505.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765498.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765513.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765501.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765502.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765509.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-227844",
    "giataCode" : 227844,
    "name" : "Park Inn by Radisson Oslo",
    "rating" : 3.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.91107548116295,
      "longitude" : 10.74071110000002
    },
    "mapZoom" : 15,
    "mythosInfo" : null,
    "leadText" : "<p>Mitten im pulsierenden Stadtzentrum Oslos ist das moderne Dreisternehotel der ideale Ausgangspunkt für Ihren Städtetrip in die beliebte norwegische Hauptstadt.</p>",
    "textInfo" : {
      "situation" : "<p>Mitten im dynamischen Zentrum geniesst das Hotel eine äusserst zentrale Lage in Oslo und ist umgeben von diversen Restaurants, Bars und zahlreichen Geschäften. Bis zum bekannten Opernhaus mit seinem markanten begehbaren Dach sind es ca. 800 m. Das beliebte Einkaufs- und Unterhaltungsviertel Aker Brygge am Hafen erreichen Sie nach rund 1 km. Das königliche Schloss mit seinem herrlichen Schlosspark ist ebenfalls etwa 1 km entfernt. Bis zum Hauptbahnhof Oslo sind es ca. 800 m. Die nächste Tramhaltestelle Ovre Slottsgate ist knapp 100 m entfernt.</p>",
      "facilityFeatures" : "<p>Das Park Inn by Radisson Oslo verfügt über einen grosszügigen Empfangsbereich mit Réception und WLAN (gratis). Zudem bietet das Hotel einen Frühstücksraum und eine Bar.</p>",
      "accommodationFeatures" : "<p>Die modern und stilvoll eingerichteten <b>Zimmer</b> (ca. 22 m<sup>2</sup>) verfügen über Dusche, WC, Föhn; Telefon, TV, WLAN (gratis), Gratissafe, Tee-/Kaffeekocher, Klimaanlage. Die <b>Suiten</b> (ca. 30 m<sup>2</sup>) sind bei gleicher Grundausstattung geräumiger.</p>",
      "rooms" : "118",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "<p>Ohne Mahlzeiten. Auf Wunsch mit Frühstück buchbar.</p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>***</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : false,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749523.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749523.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749545.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749525.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749539.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749520.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749527.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749517.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749602.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749586.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749537.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749547.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749569.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-69282",
    "giataCode" : 69282,
    "name" : "Clarion Collection Bastion",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.90819633,
      "longitude" : 10.74528293
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Boutiquehotel im englischen Stil mit einzigartigem Design und persönlicher Atmosphäre im Herzen der Stadt.</p>",
    "textInfo" : {
      "situation" : "<p>Das Hotel befindet sich im Kvadraturen-Viertel und ist etwa 500 m von der Altstadt, dem Opernhaus und dem Bahnhof entfernt. Den Hafen erreichen Sie nach rund 800 m. In der Nähe des Hotels befinden sich diverse Restaurants, Bars und Einkaufsmöglichkeiten. Der Flughafen Oslo ist ca. 50 km entfernt.</p>",
      "facilityFeatures" : "<p>Das Boutiquehotel verfügt über einen gemütlichen Empfangsbereich mit Réception und WLAN (gratis). Frühstücksraum.</p>",
      "accommodationFeatures" : "<p>Alle Zimmer verfügen über Bad oder Dusche, WC, Föhn; Telefon, Sat.-TV, WLAN (gratis), Minikühlschrank, Klimaanlage.</p>",
      "rooms" : "99",
      "sportFree" : "",
      "sportPaid" : "<p>Fitnessraum. <b>Wellness:</b> Sauna.</p>",
      "activities" : "",
      "forKids" : "",
      "catering" : "<p>Ohne Mahlzeiten.</p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : false,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : false,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : true,
        "rooms200" : false,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/305/305269.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/305/305269.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/305/305265.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/305/305261.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/305/305262.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/305/305267.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/305/305264.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/305/305266.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/305/305263.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/305/305268.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-982174",
    "giataCode" : 982174,
    "name" : "Clarion Hotel Oslo",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.908097,
      "longitude" : 10.758613
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Stilvolles und modernes Viersternehotel mit Kunstausstellung. Im Herzen des neuen Bjorvika-Viertels ist dies der ideale Ausgangspunkt für Ihre unvergessliche Entdeckungstour.</p>",
    "textInfo" : {
      "situation" : "<p>Inmitten des neuen und architektonisch interessanten Viertels Bjorvika, das ehemals ein Containerhafen war. Rund um das Hotel finden Sie zahlreiche Restaurants und Bars. Beliebte Fotomotive wie der trendige Barcode, eine Häuserzeile bestehend aus 12 Hochhäusern, welche als neue Skyline gilt, wie auch die charakteristische Fussgängerbrücke Akrobaten oder das weltbekannte weisse Opernhaus befinden sich in einem Umkreis von ca. 300 m. Der Beginn der Einkaufsstrasse Karl Johans gate ist rund 600 m entfernt. Bis zur Domkirche sind es etwa 900 m. Den Hauptbahnhof erreichen Sie nach knapp 500 m. Die Tramhaltestelle Bjorvika befindet sich vor dem Hotel.</p>",
      "facilityFeatures" : "<p>Das Clarion Hotel Oslo ist in einem modernen Gebäude untergebracht, welches sich optimal in das neue Viertel Bjorvika einfügt. Zur Einrichtung gehören ein einladender Empfangsbereich mit Réception, WLAN (gratis) und restauriertem Gemälde von Edvard Munch. Zudem bietet das Hotel einen Frühstücksraum und eine Bar. Des Weiteren beherbergt das Hotel eine Kunstausstellung.</p>",
      "accommodationFeatures" : "<p>Die modern und geschmackvoll eingerichteten <b>Zimmer</b> (18–24 m<sup>2</sup>) verfügen über Dusche, WC, Föhn, Telefon, TV, WLAN (gratis), Gratissafe, Minibar, Kaffeemaschine. Die <b>Deluxe-Zimmer </b>(ca. 30 m<sup>2</sup>) mit Bad oder Dusche bieten zusätzlich Bademäntel und Hausschuhe; teilweise mit Balkon. Die<b> Suiten</b> (ca. 35 m<sup>2</sup>) sind gleich ausgestattet wie die Deluxe-Zimmer und bestehen aus 1 Schlafzimmer und 1 optisch abgetrennten Wohnbereich.</p>",
      "rooms" : "255",
      "sportFree" : "<p>Fitnessraum.</p>",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "<p>Frühstück.</p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : false,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765358.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765358.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765351.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765347.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765352.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765361.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765357.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/765/765365.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-64923",
    "giataCode" : 64923,
    "name" : "Clarion Collection Gabelshus",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.91367403,
      "longitude" : 10.709057010000038
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Charmantes Viersternehotel an ausgezeichneter Lage.</p>",
    "textInfo" : {
      "situation" : "<p>Nur knapp 3 km vom Stadtzentrum von Oslo mit zahlreichen Einkaufs- und Unterhaltungsmöglichkeiten gelegen. Anschluss an öffentliche Verkehrsmittel befinden sich in unmittelbarer Nähe. Zum Flughafen von Oslo sind es etwa 53 km. </p>",
      "facilityFeatures" : "<p>Für Ihren Komfort verfügt das gehobene Stadthotel auf 5 Etagen über Empfangsbereich mit Réception, Zimmerservice (gegen Gebühr), TV-Ecke, WLAN (gratis), Bibliothek, Cheminée. A-la-carte-Restaurant und Bar. </p>",
      "accommodationFeatures" : "<p>Alle Zimmer verfügen über Bad oder Dusche, WC, Föhn; Telefon, Sat.-TV, WLAN (gratis), Minibar, Mietsafe.</p>",
      "rooms" : "43",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "<p>Alle gängigen Kreditkarten werden im Hotel akzeptiert.</p>",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : true,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/303/303844.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/303/303844.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/303/303431.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/303/303843.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/303/303432.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/303/303433.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/303/303841.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-19816",
    "giataCode" : 19816,
    "name" : "Radisson Blu Scandinavia Hotel",
    "rating" : 3.5,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 59.9186507,
      "longitude" : 10.73379637
    },
    "mapZoom" : 15,
    "mythosInfo" : null,
    "leadText" : "<p>Das Viersternehotel im Herzen von Oslo punktet mit seiner atemberaubenden Aussicht, moderner Einrichtung sowie Wellness und guter Gastronomie. Ideal für Ihre Städtereise.</p>",
    "textInfo" : {
      "situation" : "<p>Das Hotel an zentraler Lage ist umgeben von verschiedenen Restaurants, Bars und Geschäften. Den weitläufigen, gepflegten Schlosspark erreichen Sie nach rund 150 m und das königliche Schloss nach etwa 400 m. Bis zum Nationaltheater sind es ca. 500 m. Das beliebte Einkaufs- und Unterhaltungsviertel Aker Brygge ist rund 1 km entfernt. Das beliebte Opernhaus mit seinem begehbaren weissen Dach erreichen Sie nach knapp 2 km. Bis zum Hauptbahnhof sind es rund 1,5 km. Die Tramhaltestelle Hobergs plass befindet sich vor dem Hotel und die nächste U-Bahnstation Nationaltheatret ist ca. 500 m entfernt.</p>",
      "facilityFeatures" : "<p>Das Radisson Blu Scandinavia Hotel zählt 22 Etagen und verfügt über einen Empfangsbereich mit Réception und WLAN (gratis). Zu den gastronomischen Angeboten gehören ein A-la-carte-Restaurant mit regionaler Küche und internationalen Spezialitäten und eine Bar mit fantastischem Panoramablick über die Stadt und den Fjord.</p>",
      "accommodationFeatures" : "<p>Die stilvoll eingerichteten <b>Zimmer</b> (ca. 22 m<sup>2</sup>) verfügen über Dusche, WC, Föhn; Telefon, TV, WLAN (gratis), Gratissafe, Tee-/Kaffeekocher, Klimaanlage. Auch mit Blick auf den Fjord buchbar. Die <b>Suiten</b> (ca. 42 m<sup>2</sup>) sind geräumiger und verfügen zusätzlich zur Grundausstattung über Bademäntel, Hausschuhe sowie eine Nespresso-Maschine.</p>",
      "rooms" : "499",
      "sportFree" : "<p>Fitnessraum. <b>Wellness:</b> Hallenbad, Sauna.</p>",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "<p>Ohne Mahlzeiten. Auf Wunsch mit Frühstück buchbar.</p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : true
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749437.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749437.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749453.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749448.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749425.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749458.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749492.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749456.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749465.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749462.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749439.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749463.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749480.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749444.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749445.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/749/749488.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-40806",
    "giataCode" : 40806,
    "name" : "Scandic Grand Tromsø",
    "rating" : 3.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 69.64796734174564,
      "longitude" : 18.953802626983588
    },
    "mapZoom" : 18,
    "mythosInfo" : null,
    "leadText" : "<p>Das moderne Hotel liegt mitten im Zentrum von Tromsø, von wo aus die Sehenswürdigkeiten gut zu Fuss erreichbar sind.</p>",
    "textInfo" : {
      "situation" : "<p>Direkt an der Einkaufsstrasse Storgata. Der Flughafenbus hält in der Nähe des Hotels.</p>",
      "facilityFeatures" : "<p>Im Grand Restaurant geniesst man das grosse Frühstücksbuffet. Im Gründer Café und Bar werden in ungezwungener Atmosphäre Mittag- und Nachtessen serviert. Am Wochenende kann man hier das Tanzbein schwingen. Tee und Kaffee stehen gratis in der Lobby zur Verfügung. Parkplatz (gegen Gebühr). WLAN gratis.</p>",
      "accommodationFeatures" : "<p>Die farbenfrohen Zimmer verfügen über Holzböden und sind mit Bad oder Dusche, WC, Föhn, einem kleinen Kühlschrank und Flachbildschirm-TV ausgestattet. Alle Zimmer haben auch einen kleinen Schreibtisch.</p>",
      "rooms" : "133",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>***</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/318/318255.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/318/318255.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/318/318254.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/318/318253.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/318/318257.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/318/318256.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-91831",
    "giataCode" : 91831,
    "name" : "Quality Hotel Saga",
    "rating" : 3.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 69.6480839,
      "longitude" : 18.957745700000032
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Ein modernes Mittelklassehotel an idealster Lage, inmitten von Tromsø. </p>",
    "textInfo" : {
      "situation" : "<p>Das Hotel liegt im Zentrum von Tromsø, neben dem Hafen und dem Flughafen-Expressbus-Terminal. Wichtige Sehenswürdigkeiten wie der Dom von Tromsø, das Universitätsmuseum, das arktische Erlebniszentrum Polaria sowie das Polarmuseum liegen in Gehdistanz vom Hotel entfernt. Verschiedene Bars und Restaurants sind in unmittelbarer Nähe vom Hotel gelegen.</p>",
      "facilityFeatures" : "<p>Im Buffet-Restaurant werden ein ausgewogenes Frühstück und Nachtessen eingenommen. Am Nachmittag werden gratis Kaffee, Tee und frische Waffeln angeboten. Parkmöglichkeiten gegen Gebühr. Nichtraucherhotel. WLAN gratis.</p>",
      "accommodationFeatures" : "<p>Die modernen Zimmer verfügen über einen fantastischen Ausblick auf die Eismeerkathedrale, den Hausberg von Tromsø oder auf das Stadtzentrum. Alle Zimmer sind mit Bad oder Dusche, WC, Föhn, Hosenpresse, Minibar und Kaffee-/Teekocher ausgestattet. Zimmer mit Verbindungstür auf Anfrage. </p>",
      "rooms" : "103",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "<p>Frühstücksbuffet</p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>***</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : false,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : false,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/316/316599.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/316/316599.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/316/316600.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-72331",
    "giataCode" : 72331,
    "name" : "Clarion Collection With",
    "rating" : 3.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 69.650461,
      "longitude" : 18.959879
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Das charmante Hotel empfängt die Gäste mit einem aufmerksamen Service und besticht durch seine persönliche Atmosphäre. Am Nachmittag werden den Gästen kostenlos Kaffee, Tee und frische Waffeln angeboten.</p>",
    "textInfo" : {
      "situation" : "<p>Dank der zentralen Lage sind die wichtigsten Sehenswürdigkeiten sowie eine grosse Auswahl an Restaurants, Bars und Einkaufsmöglichkeiten gut erreichbar. Ebenfalls nur wenige Meter entfernt ist die Anlegestelle der Hurtigruten.</p>",
      "facilityFeatures" : "<p>Den Gästen stehen gemütliche Aufenthaltsräume zur Verfügung. Das Hotel verfügt über kein eigenes Restaurant, jedoch befinden sich in unmittelbarer Nähe des Hotels mehrere Restaurants. Ein grosszügiger Sauna- und Erholungsbereich im obersten Stock des Hotels sorgt dafür, dass sich die Gäste rundum wohl fühlen. Gratis-WLAN.</p>",
      "accommodationFeatures" : "<p>Das Hotel bietet geschmackvoll, im maritimen Stil eingerichtete Zimmer. Zur Ausstattung gehören Dusche, WC, Föhn, TV, Telefon, Minibar und Hosenpresse.</p>",
      "rooms" : "76",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : false,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : true,
        "alaCarteRestaurants" : false,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : false,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : false,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : true,
        "rooms200" : false,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/128/128441.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/128/128441.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/128/128442.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-34108",
    "giataCode" : 34108,
    "name" : "Radisson Blu Hotel Tromsø",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 69.64917858203833,
      "longitude" : 18.96062920943143
    },
    "mapZoom" : 18,
    "mythosInfo" : null,
    "leadText" : "<p>Dieses bekannte Hotel begrüsst Sie am Hafen von Tromsø. Die Schiffe der Hurtigruten legen in nächster Nähe an.</p>",
    "textInfo" : {
      "situation" : "<p>Direkt am Hafen von Tromsø. Von hier aus sind die Sehenswürdigkeiten gut zu Fuss erreichbar. Der Flughafenbus hält ganz in der Nähe.</p>",
      "facilityFeatures" : "<p>Das Restaurant Aurora bietet regionale Gerichte mit frischen Zutaten an. Die Yonas Pizzeria ist für ihre exzellenten Pizzas bekannt. Im Rorbua Pub können Sie ein Bier aus der nördlichsten Brauerei der Welt geniessen. An gewissen Abenden sogar bei Livemusik. Der Fitnessraum und die Sauna befinden sich in der 10. Etage. Parkplatz (gegen Gebühr). WLAN gratis.</p>",
      "accommodationFeatures" : "<p>Die meisten Zimmer bieten eine Aussicht über die Stadt, die Eismeerkathedrale oder die Meerenge von Tromsø und sind in hellen, angenehmen Farbtönen gehalten. Sie sind mit Bad oder Dusche, WC, TV, Minibar und einem kleinen Schreibtisch ausgestattet.</p>",
      "rooms" : "269",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : true,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : true,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/520/520701.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/520/520701.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/318/318602.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/520/520703.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/520/520702.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/520/520705.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-408734",
    "giataCode" : 408734,
    "name" : "Clarion Hotel The Edge",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 69.64722337491544,
      "longitude" : 18.955999716671727
    },
    "mapZoom" : 17,
    "mythosInfo" : null,
    "leadText" : "<p>Ein neues und modernes Hotel mit innovativer Architektur an idealster Lage im Zentrum von Tromsø.</p>",
    "textInfo" : {
      "situation" : "<p>Das Hotel liegt im Zentrum von Tromsø direkt am Wasser. Das Hurtigruten-Terminal ist in wenigen Gehminuten erreichbar. Zum Flughafen sind es ca. 7 km.</p>",
      "facilityFeatures" : "<p>Das Restaurant Kitchen&amp;Table bietet in einem neuen Restaurantkonzept feines Essen. Die Skybar befindet sich in der 11. Etage: Hier lassen sich Drinks und Musik bei einer schönen Aussicht geniessen. Ein Fitnesszentrum (gegen Gebühr) kann vom Hotel direkt erreicht werden. Gratis-WLAN.</p>",
      "accommodationFeatures" : "<p>Die modernen Zimmer sind mit einem kleinen Schreibtisch, TV, Minibar, Bügeleisen, Bad oder Dusche und WC eingerichtet.</p>",
      "rooms" : "290",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : false,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/565/565413.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/565/565413.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/565/565407.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/565/565409.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/565/565410.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/565/565412.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/128/128516.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-228464",
    "giataCode" : 228464,
    "name" : "Thon Tromso",
    "rating" : 3.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 69.64852204384395,
      "longitude" : 18.95279466137697
    },
    "mapZoom" : 17,
    "mythosInfo" : null,
    "leadText" : "<p>Modernes Hotel im Zentrum von Tromsø in der Nähe der Hauptgeschäftsstrasse. Geräumige Zimmer und gutes Frühstücksbuffet.</p>",
    "textInfo" : {
      "situation" : "<p>Das Hotel liegt direkt an der Ecke der Haupteinkaufsstrasse Storgata. In der Umgebung befinden sich zahlreiche Geschäfte, Restaurants, Cafés und öffentliche Verkehrsmittel. Die Fähranlegestelle Terminal Hurtigruten ist rund 400 m entfernt. Das bekannte Polarmuseum erreicht man nach ca. 1 km, die Kathedrale nach etwa 1,5 km. Der Flughafen ist ungefähr 4 km entfernt.</p>",
      "facilityFeatures" : "<p>Das Hotel verfügt über einen Empfangsbereich mit Réception, Lobby und WLAN (gratis). Ein Frühstücksraum. Parkplatz (gegen Gebühr).</p>",
      "accommodationFeatures" : "<p>Die geräumigen Zimmer verfügen über Bad/Dusche, WC, Föhn; Telefon, Radio, WLAN (gratis), Minibar.</p>",
      "rooms" : "152",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>***</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : false,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : false,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : true,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/348/348703.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/348/348703.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/348/348704.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/348/348709.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/348/348706.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/348/348705.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/348/348707.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/348/348708.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-51232",
    "giataCode" : 51232,
    "name" : "Clarion Collection Hotel Aurora",
    "rating" : 3.5,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 69.65011507746192,
      "longitude" : 18.959572419079564
    },
    "mapZoom" : 15,
    "mythosInfo" : null,
    "leadText" : "<p>Das beliebte Hotel empfängt die Gäste mit einem freundlichen Service und angenehmer Atmosphäre. Tee und Kaffee stehen jederzeit gratis zur Verfügung. Am Nachmittag werden zusätzlich noch Süssigkeiten aufgetischt. </p>",
    "textInfo" : {
      "situation" : "<p>Dank der zentralen Lage sind die Sehenswürdigkeiten sowie eine grosse Auswahl an Restaurants, Bars und Einkaufsmöglichkeiten gut erreichbar. Ebenfalls nur wenige Meter entfernt ist die Anlegestelle der Hurtigruten.</p>",
      "facilityFeatures" : "<p>Den Gästen steht ein kleiner Aufenthaltstraum mit Bar zur Verfügung. Im Buffetrestaurant wird das Frühstück und Nachtessen eingenommen. In der 5. Etage befinden sich ein kleiner Fitnessraum und eine Sauna sowie ein Jacuzzi auf der Terrasse mit einer schönen Panoramasicht. WLAN gratis.</p>",
      "accommodationFeatures" : "<p>Das Hotel bietet 121 geschmackvoll eingerichtete Zimmer. Zur Ausstattung gehören Dusche, WC, TV, Telefon und eine Minibar.</p>",
      "rooms" : "121",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : true,
        "alaCarteRestaurants" : false,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/090/090706.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/090/090706.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/090/090707.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/090/090709.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-70662",
    "giataCode" : 70662,
    "name" : "Thon Polar",
    "rating" : 3.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 69.6484313,
      "longitude" : 18.953499999999963
    },
    "mapZoom" : 17,
    "mythosInfo" : null,
    "leadText" : "<p>Das freundliche Cityhotel bietet eine zentrale Lage mit Nähe zu zahlreichen Sehenswürdigkeiten.</p>",
    "textInfo" : {
      "situation" : "<p>Das Hotel liegt im Stadtzentrum von Tromsø. Einkaufsmöglichkeiten, Restaurants und Cafés befinden sich in der Nähe. Zahlreiche Sehenswürdigkeiten und Museen sind bequem erreichbar. Eine Flughafenbus-Haltestelle liegt nur ca. 100 m vom Hotel entfernt. Zum Flughafen Tromsø-Langes sind es ca. 4 km.</p>",
      "facilityFeatures" : "<p>Das Hotel bietet eine Empfangshalle mit Réception, Bar, WLAN (gratis), Frühstücksraum, A-la-carte-Restaurant und Parkplatz. Das Hotel bietet weiterhin eine Autovermietung und einen Wäscheservice. In dem 9-stöckigen Hotel wird Norwegisch und Englisch gesprochen. Für Gäste, welche auf einen Rollstuhl angewiesen sind, bietet das Hotel einen Aufzug und Rampen.</p>",
      "accommodationFeatures" : "<p>Alle Zimmer mit Bad/Dusche, WC, Föhn; Telefon, Sat.-TV, WLAN gratis, Mietsafe und Minibar (gegen Gebühr).</p>",
      "rooms" : "130",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>***</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : true,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : true,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/349/349167.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/349/349167.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/318/318465.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/349/349175.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/349/349168.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/318/318468.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/318/318472.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/349/349174.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/349/349173.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/349/349165.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/349/349171.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-70758",
    "giataCode" : 70758,
    "name" : "Scandic Ishavshotel",
    "rating" : 3.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 69.64954796165591,
      "longitude" : 18.96193276301267
    },
    "mapZoom" : 15,
    "mythosInfo" : null,
    "leadText" : "<p>Das Hotel geniesst eine einzigartige Lage auf dem Kai und fast alle Zimmer bieten einen bezaubernden Blick auf die Umgebung. Ein ideales Hotel für Hurtigruten-Passagiere wie auch Tromsø-Besucher.</p>",
    "textInfo" : {
      "situation" : "<p>Direkte Lage am Meer und auf dem Kai. Das Hurtigruten-Terminal und der Busbahnhof sind wenige Meter vom Hotel entfernt. Viele der Sehenswürdigkeiten sind einfach zu Fuss erreichbar.</p>",
      "facilityFeatures" : "<p>Das A-la-carte-Restaurant bietet ein Menü mit den frischesten Meeresfrüchten, Fisch und lokal bezogenen Fleischprodukten, die in der offenen Küche auf einem original Josper-Grill zubereitet werden. Die Bar bietet eine breite Auswahl an klassischen Cocktails und lokalem Bier an. WLAN gratis.</p>",
      "accommodationFeatures" : "<p>Fast alle Zimmer liegen am Ende des Kais und bieten eine atemberaubende Aussicht auf den Hafen und die Stadt. Sie sind mit Dusche, WC, TV und Telefon ausgestattet.</p>",
      "rooms" : "214",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : false,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : true,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/128/128453.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/128/128453.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/128/128454.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/510/510800.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/510/510803.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-1326613",
    "giataCode" : 1326613,
    "name" : "Hotel Mestari",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.16697910917767,
      "longitude" : 24.93373042394256
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Geniessen Sie ihren Aufenthalt in der finnischen Hauptstadt im Hotel Mestari, wo industrielle Eleganz auf lateinamerikanische Küche und hohen Komfort trifft.</p>",
    "textInfo" : {
      "situation" : "<p>Optimal gelegen, profitiert das Hotel von der nahen Strassenbahn-Haltestelle «Kampintori» (ca. 200 m) und der rund 400 m entfernten U-Bahnstation «Kamppi», wo sich auch ein Einkaufszentrum befindet. Im Umkreis von etwa 500 m befindet sich eine grosse Auswahl an Cafés, Restaurants und Einkaufsmöglichkeiten. Der Hauptbahnhof ist nach knapp 1 km erreicht. </p>",
      "facilityFeatures" : "<p>Im industriellen Stil gehalten verfügt das Hotel Mestari über einen Empfangsbereich mit Reception und WLAN (gratis). Für ausgewählte Kulinarik sorgen der Frühstücksraum, das Bistro mit lateinamerikanischer Küche, eine Bar und ein Café. Parkplatz gegen Gebühr.</p>",
      "accommodationFeatures" : "<p>Komfortabel und elegant eingerichtet verfügen die <b>Doppelzimmer </b>über Dusche, WC, Föhn; Telefon, TV, WLAN (gratis), Gratissafe, Minibar, Tee-/Kaffeekocher, Klimaanlage. Die <b>Suiten </b>sind bei der gleichen Einrichtung geräumiger und verfügen zusätzlich über Bademantel, Hausschuhe und einen separaten Wohnbereich.</p>",
      "rooms" : "237",
      "sportFree" : "<p>Fitnessraum.</p>",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : true,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : true,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/730/730250.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/730/730250.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/730/730218.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/730/730238.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/730/730242.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/730/730249.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/730/730253.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/730/730248.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/730/730246.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-21195",
    "giataCode" : 21195,
    "name" : "Scandic Park",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.179042329287256,
      "longitude" : 24.927637574066175
    },
    "mapZoom" : 13,
    "mythosInfo" : null,
    "leadText" : "<p>Das Hotel Scandic Park mit entspannter Atmosphäre ist sowohl für Unternehmungslustige als auch Familien ein ideales Hotel, um die Stadt zu erkunden.</p>",
    "textInfo" : {
      "situation" : "<p>Das Hotel liegt an der schönen Töölönbucht, etwas ausserhalb vom Stadtzentrum (ca. 1 km). In der Nähe des Hotels, im Umkreis von rund 800 m, befinden sich unter anderem die finnische Nationaloper, die Finlandia Hall, das Konzerthaus sowie das Olympiastadion. Zum Vergnügungspark Linnanmäki sind es ca. 1,5 km. Bushaltestelle Hesperian Puisto direkt gegenüber dem Hotel. Zum Hauptbahnhof sind es ca. 1,4 km. </p>",
      "facilityFeatures" : "<p>Das Hotel verfügt über eine Réception und Lobby mit 24-Stunden-Shop und WLAN (gratis). Das A-la-carte-Restaurant mit Bar bietet skandinavische und europäische Gerichte an. Garage gegen Gebühr. E–Ladestation gegen Gebühr.</p>",
      "accommodationFeatures" : "<p>Grosse und gemütliche <b>Zimmer</b><b> </b>(ca. 25 m<sup>2</sup>) mit Bad oder Dusche, WC, Föhn; Telefon, TV, WLAN (gratis), Gratissafe, Minibar. Die <b>Superior–Zimmer</b> (ca. 25 m<sup>2</sup>) bieten zusätzlich Bademäntel und einen Tee-/Kaffeekocher. Die <b>Junior Suiten</b> (ca. 55 m<sup>2</sup>) verfügen zusätzlich über einen separaten Wohnraum sowie eine Sauna. Zimmerservice.</p>",
      "rooms" : "523",
      "sportFree" : "<p><b>Wellness: </b>Hallenbad, Whirlpool, Sauna.</p>",
      "sportPaid" : "<p>Fahrradverleih.</p>",
      "activities" : "",
      "forKids" : "<p>Spielzimmer.</p>",
      "catering" : "<p>Frühstück.</p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : true
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : true,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : false,
        "rooms999" : true,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : true
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767527.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767527.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767519.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767492.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767488.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767520.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767524.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767529.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767530.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767514.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767535.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767502.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767517.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767496.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767512.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767525.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767504.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-38218",
    "giataCode" : 38218,
    "name" : "Radisson Blu Seaside Helsinki",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.16201952,
      "longitude" : 24.92405718
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Hotel der gehobenen Mittelklasse, in dem sich Geschäftsreisende und Feriengäste wohl fühlen. Profitieren Sie von der guten Lage zur Erkundung der Stadt und vom ausgezeichneten Service.</p>",
    "textInfo" : {
      "situation" : "<p>Das Hotel befindet sich im schnell wachsenden Ruoholahti Geschäftsbezirk mit zahlreichen Hightech-Firmen. Wie der Name schon sagt, liegt das Hotel am Meer und bietet wundervolle Ausblicke auf den Golf von Finnland. Der Flughafen Helsinki-Vantaa International ist etwa 21 km entfernt.</p>",
      "facilityFeatures" : "<p>Das Hotel bietet folgende Annehmlichkeiten: Lobby mit Réception, WLAN (gratis), Restaurant, Bar, Parkplatz, Wäscheservice, Geldwechselstube, Kiosk.</p>",
      "accommodationFeatures" : "<p>Die Zimmer bieten eine Mischung aus moderner Eleganz gepaart mit einer Gemütlichkeit, die Ihnen das Gefühl gibt, zu Hause zu sein. Zimmer mit Bad oder Dusche, WC, Föhn; Telefon, Sat.-TV, WLAN (gratis), Tee-/Kaffeekocher, Minibar, Mietsafe, Klimaanlage.</p>",
      "rooms" : "336",
      "sportFree" : "",
      "sportPaid" : "<p>Fitnessraum.<b> Wellness: </b>Saunabereich im obersten Stockwerk nutzen, der zudem einen fabelhaften Blick über die Stadt und das Meer bietet.</p>",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "<p>Das Hotel akzeptiert folgende Zahlungsmöglichkeiten: EC, JCB, American Express, Diners Club, Visa, MasterCard.</p>",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****(*)</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/524/524267.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/524/524267.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/524/524271.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/523/523784.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/065/065168.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/524/524270.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/524/524268.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/523/523794.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/075/075373.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/072/072961.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/523/523791.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/524/524272.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/524/524269.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/523/523789.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/523/523793.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/523/523781.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-21191",
    "giataCode" : 21191,
    "name" : "Scandic Grand Marina",
    "rating" : 3.5,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.165777725253704,
      "longitude" : 24.964262558196992
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Das ehemalige, denkmalgeschützte Lager und Kontorhaus wurde mit viel Flair in ein Hotel der gehobenen Mittelklasse mit maritimer Atmosphäre umgebaut. </p>",
    "textInfo" : {
      "situation" : "<p>Am Katajanokka-Hafen gelegen, 15 Gehminuten vom Stadtzentrum entfernt.</p>",
      "facilityFeatures" : "<p>Maritim eingerichtetes Restaurant, Sauna und Fitnessraum zur freien Benutzung, charmante Bar mit Ausblick auf den Hafen, kleiner Shop. Parkplatz (gegen Gebühr).</p>",
      "accommodationFeatures" : "<p>462 unterschiedlich grosse, komfortabel eingerichtete Zimmer mit Bad oder Dusche, WC, TV, Telefon, WLAN und Minibar.</p>",
      "rooms" : "462",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : true,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : true,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/076/076092.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/076/076092.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/076/076086.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/076/076088.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/076/076089.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/076/076090.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-21828",
    "giataCode" : 21828,
    "name" : "Sokos Torni",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.167790205088,
      "longitude" : 24.938589334488
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Bereits im Jahr 1928 als höchstes Gebäude Helsinkis eröffnet, besticht das traditionsreiche Hotel mit seinem eigenwilligen Charme und Ambiente im Jugendstil und Art Déco.</p>",
    "textInfo" : {
      "situation" : "<p>Mitten im Zentrum von Helsinki, an ruhiger Lage in einer Seitenstrasse gelegen.</p>",
      "facilityFeatures" : "<p>Restaurant Torni mit moderner, finnischer Küche, American-Bar für köstliche Drinks, O’Malley-Irish-Bar mit Pub-Spezialitäten und die elegante Ateljee-Bar in der regelmässig Ausstellungen finnischer Künstler stattfinden und eine grandioser Aussicht über die ganze Stadt bietet.</p>",
      "accommodationFeatures" : "<p>152 in drei verschiedenen Stilrichtungen gehaltene Zimmer mit Bad oder Dusche, WC, Föhn, TV, Telefon, WLAN, Minibar, Hosenpresse und Bügeleisen.</p>",
      "rooms" : "152",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : true,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : true,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/076/076076.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/076/076076.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-48491",
    "giataCode" : 48491,
    "name" : "Sokos Helsinki",
    "rating" : 3.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.169663503671,
      "longitude" : 24.947086572647
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Familiäres Mittelklassehotel. Die in freundlichen Farben gehaltene Ausstattung und eine ungezwungene Atmosphäre schaffen ein angenehmes Ambiente.</p>",
    "textInfo" : {
      "situation" : "<p>Im pulsierenden Zentrum des Einkaufsviertels gelegen und nur ein paar Schritte vom Senatsplatz, der Esplanadi sowie weiteren wichtigen Sehenswürdigkeiten Helsinkis entfernt.</p>",
      "facilityFeatures" : "<p>Gemütliches Restaurant Fransmanni mit französisch inspirierter Küche, trendiges Café Memphis mit internationalen Gerichten und Helsinki Club. Bar und Sauna. WLAN (gratis).</p>",
      "accommodationFeatures" : "<p>Die hübsch eingerichteten Zimmer mit Holzböden bieten Bad oder Dusche, WC, TV und Minibar.</p>",
      "rooms" : "202",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>***</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : true,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : true,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : true,
        "discoNightclub" : true,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/076/076072.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/076/076072.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/076/076073.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/465/465708.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-1350644",
    "giataCode" : 1350644,
    "name" : "Scandic Helsinki Hub",
    "rating" : 3.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.16588502501248,
      "longitude" : 24.93814440370482
    },
    "mapZoom" : 13,
    "mythosInfo" : null,
    "leadText" : "<p>Ein modernes Stadthotel an ruhiger Lage im Zentrum von Helsinki in einem Industriegebäude aus den 1920er-Jahren, das früher als Druckerei diente.</p>",
    "textInfo" : {
      "situation" : "<p>Das Hotel Scandic Helsinki Hub liegt neben dem Alten Kirchenpark. Der malerische Süden Helsinkis mit seinen Cafés, Restaurants und Galerien liegt direkt vor der Haustür. Die Kunst-Museen Ateneum und Kiasma sowie der Hauptbahnhof sind ca. 800 m entfernt. Die Tramhaltestelle Bulevardi befindet sich in rund 100 m Entfernung.</p>",
      "facilityFeatures" : "<p>Das Hotel verfügt über eine Lobby mit Réception, 24-Stunden-Shop und WLAN (gratis). Zu den gastronomischen Angeboten zählen ein italienisches A-la-carte-Restaurant und eine Bar mit Terrasse im Innenhof. Garage gegen Gebühr. E-Ladestation gegen Gebühr.</p>",
      "accommodationFeatures" : "<p>Moderne und stilvolle Zimmer im Loftstil. Die <b>Cabins </b>(21–30 m<sup>2</sup>) haben keine Fenster, mit Bad oder Dusche, WC, Föhn; Telefon, TV, WLAN (gratis), Gratissafe, Minibar. Die <b>Zimmer </b>(19–30 m<sup>2</sup>) sind mit Fenster und ansonsten gleich ausgestattet. Die <b>Superior-Zimmer</b> (22–40 m<sup>2</sup>) bieten zusätzlich Bademäntel und Hausschuhe sowie einen Tee-/Kaffeekocher, auch mit Balkon buchbar. Die <b>Junior Suiten</b> (35–43 m<sup>2</sup>) sind nochmals geräumiger. Zimmerservice.</p>",
      "rooms" : "352",
      "sportFree" : "<p>Fitnessraum. <b>We</b><b>llness:</b> Sauna. </p>",
      "sportPaid" : "<p>Fahrradverleih.</p>",
      "activities" : "",
      "forKids" : "",
      "catering" : "<p>Frühstück. </p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>***</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : true,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : true
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767472.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767472.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767473.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767478.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767477.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767474.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767479.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-254781",
    "giataCode" : 254781,
    "name" : "Scandic Paasi",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.17862203780002,
      "longitude" : 24.94792581481933
    },
    "mapZoom" : 13,
    "mythosInfo" : null,
    "leadText" : "<p>Dieses stilvoll eingerichtete Hotel verbindet auf spielerische Weise die Geschichte des Hotels mit der Gegenwart. Es bietet exzellenten Service und eine ungezwungene Atmosphäre.</p>",
    "textInfo" : {
      "situation" : "<p>Das Hotel Scandic Paasi liegt an ruhiger Lage im maritimen Stadtteil Siltasaari, im östlichen Teil des Stadtzentrums von Helsinki. Der Stadtteil Siltasaari beherbergt zahlreiche Theater und Museen und ist damit ein beliebtes Ziel für Kulturliebhaber. Die beliebtesten Sehenswürdigkeiten in Helsinki, wie der Dom, die Stadthalle oder der Marktplatz, sind ca. 1,1–1,5 km entfernt. Zum Hauptbahnhof sind es ca. 1,4 km, die Tramhaltestelle Hakaniemi befindet sich in rund 200 m Entfernung.</p>",
      "facilityFeatures" : "<p>Das Hotel verfügt über eine farbenfrohe Réception, 24-Stunden-Shop sowie eine moderne und individuell gestaltete Lobbybar mit gemütlicher Bibliothek, WLAN (gratis). Parkplatz gegen Gebühr.</p>",
      "accommodationFeatures" : "<p>Die Zimmer sind themenorientiert eingerichtet im «Conscious»-, «Leisure»- (mit Boxsäcken) oder «Spectacular»-Stil, der an die farbenfrohe Zirkusgeschichte der Region erinnert. <b>Zimmer</b> (17–35 m<sup>2</sup>) mit Bad oder Dusche, WC, Föhn; Telefon, TV, WLAN (gratis), Gratissafe. Die <b>Superior-Zimmer</b> (17–30 m<sup>2</sup>) bieten zusätzlich Bademäntel und eine Minibar. Auch mit eigener Sauna buchbar. Zimmerservice.</p>",
      "rooms" : "170",
      "sportFree" : "<p>Fitnessraum.</p>",
      "sportPaid" : "<p>Fahrradverleih.</p>",
      "activities" : "",
      "forKids" : "",
      "catering" : "<p>Frühstück.</p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : false,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : true,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767570.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767570.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767564.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767582.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767557.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767562.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767586.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767567.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767554.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767543.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767589.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767578.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767583.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767574.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767561.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/767/767579.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-54794",
    "giataCode" : 54794,
    "name" : "Hilton Helsinki Kalastajatorppa",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.1905,
      "longitude" : 24.8766
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Umgeben von grüner Natur mit Sicht auf die malerische Bucht Laajalahti wird die Entspannung Sie bestimmt nicht verlassen. Erleben Sie das finnische Ambiente und lassen Sie sich verwöhnen.</p>",
    "textInfo" : {
      "situation" : "<p>An der westlichen Küste der historischen Hauptstadt Helsinki. Die nächste Strassenbahnstation «Fiskartorpsvägen» erreichen Sie in rund 260 m. Das Stadtzentrum mit diversen Bars, Restaurants und Einkaufsmöglichkeiten befindet sich in etwa 5 km Distanz. Bis zum Flughafen Helsinki-Vantaa sind es ca. 19 km.</p>",
      "facilityFeatures" : "<p>Das grossräumige Hilton Helsinki Kalastajatorppa begrüsst Sie in einer einladenden Empfangshalle mit Réception und WLAN (gratis). Für das kulinarische Wohl sorgen ein A-la-carte-Restaurant und ein Frühstücks-Buffetrestaurant mit internationalen Küchen. Zur Erfrischung steht Ihnen eine Bar zur Verfügung. Der hoteleigene Strand befindet sich etwa 100 m vor dem Hotel. Die Benutzung von Sonnenschirmen und Liegestühlen am Strand ist gegen Gebühr.</p>",
      "accommodationFeatures" : "<p>Die gemütlichen <b>Zimmer </b>verfügen über Dusche, WC, Föhn; Telefon, TV, WLAN (gratis), Safe, Minibar, Heizung/Klimaanlage; buchbar mit Bettsofa oder Balkon mit Meer-/ Parksicht. Die <b>Suiten </b>sind bei gleicher Ausstattung geräumiger und verfügen zusätzlich über Balkon mit Meerblick, Bademantel und Hausschuhe.</p>",
      "rooms" : "238",
      "sportFree" : "<p>Fitnessraum. <b>Wellness</b>: Spa mit Hallenbad und Sauna.</p>",
      "sportPaid" : "<p><b>Wellness</b>: Spa mit diversen Massagen.</p>",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : false,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : true,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : true
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : false,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : true,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758198.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758198.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758191.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758234.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758162.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758163.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758165.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758164.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758218.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758170.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758168.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758171.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758178.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758201.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758190.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758206.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758203.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758213.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758187.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758195.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-1275502",
    "giataCode" : 1275502,
    "name" : "Scandic Grand Central Helsinki",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.17203663508988,
      "longitude" : 24.942984373016348
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Das einzigartige Hotel befindet sich in einem beeindruckenden Jugendstilgebäude an bester Lage im Zentrum von Helsinki. Hier verschmilzt altmodischer Charme mit modernem Stil.</p>",
    "textInfo" : {
      "situation" : "<p>Das Hotel Scandic Grand Central liegt direkt am Hauptbahnhof und neben dem Nationaltheater. Die Kunstgalerie Ateneum, der Kaisaniemi–Park sowie zahlreiche Restaurants und Geschäfte befinden sich in einem Umkreis von ca. 100 m.</p>",
      "facilityFeatures" : "<p>Die Lobby mit Loungebereich und Réception und WLAN (gratis) ist das Herzstück des Hotels. Zu den gastronomischen Angeboten zählen ein A-la-carte-Restaurant mit europäischer Küche und eine Bar.</p>",
      "accommodationFeatures" : "<p>Zeitlos, elegant eingerichtete <b>Zimmer</b> (17–24 m<sup>2</sup>) im neuen Teil des Hotels mit Dusche, WC, Föhn; Telefon, TV, WLAN (gratis), Gratissafe, Minibar. Die <b>Classic-Zimmer </b>(13–26 m<sup>2</sup>) befinden sich im ursprünglichen Teil des Hotels, einige Zimmer haben eine Badewanne. Die <b>Superior-Zimmer</b> (20–30 m<sup>2</sup>) bieten zusätzlich Bademäntel und einen Tee-/Kaffeekocher. Die <b>Junior Suiten </b>(35–45 m<sup>2</sup>) sind noch grösser und bieten einen Blick auf den ruhigen Innenhof. Zimmerservice.</p>",
      "rooms" : "491",
      "sportFree" : "<p>Fitnessraum.</p>",
      "sportPaid" : "<p>Fahrradverleih.</p>",
      "activities" : "",
      "forKids" : "",
      "catering" : "<p>Frühstück.</p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : true,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766414.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766414.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766420.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766422.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766417.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766468.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766463.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766486.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766418.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766440.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766416.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766430.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766431.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766432.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766412.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766413.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-227234",
    "giataCode" : 227234,
    "name" : "Scandic Hakaniemi Helsinki",
    "rating" : 3.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.1791420094672,
      "longitude" : 24.94956648446987
    },
    "mapZoom" : 16,
    "mythosInfo" : null,
    "leadText" : "<p>Ein modernes Hotel mit freundlicher Atmosphäre erwartet Sie. Dank der guten Anbindung an den öffentlichen Verkehr eignet es sich hervorragend zur Erkundung der Stadt.</p>",
    "textInfo" : {
      "situation" : "<p>Das Hotel liegt im Stadtteil Hakaniemi. Im Umkreis von rund 200 m befinden sich einige Restaurants, Geschäfte, die Markthalle von Hakaniemi sowie das Helsinki-Stadttheater. Zum Senatsplatz mit dem Dom sind es ca. 1 km. Gegenüber dem Hotel liegen die Bushaltestelle und Metrostation Hakaniemi. Zum Hauptbahnhof sind es ca. 1,5 km. </p>",
      "facilityFeatures" : "<p>Das Hotel Scandic Hakaniemi verfügt über eine Lobby mit Bar, Réception, 24–Stunden–Shop und WLAN (gratis) sowie einen Frühstücksraum. Garage gegen Gebühr. E–Ladestation gegen Gebühr.</p>",
      "accommodationFeatures" : "<p>Moderne <b>Zimmer </b>(16–20 m<sup>2</sup>) mit Dusche, WC, Föhn; Telefon, TV, WLAN (gratis), Gratissafe, Minibar. Die <b>Superior-Zimmer </b>(16–20 m<sup>2</sup>) bieten zusätzlich Bademäntel und einen Tee-/Kaffeekocher.</p>",
      "rooms" : "152",
      "sportFree" : "<p>Fitnessraum. <b>Wellness: </b>Sauna.</p>",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "<p>Spielzimmer.</p>",
      "catering" : "<p>Frühstück.</p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>***</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : true,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : false,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : true,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : true,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : true
      }
    },
    "hero" : null,
    "images" : null
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-39984",
    "giataCode" : 39984,
    "name" : "Holiday Inn Helsinki City Centre",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.17227787317152,
      "longitude" : 24.939532224853565
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Die lebendige Hauptstadt mit grüner Lunge wird Sie begeistern – von strahlend grünen Parks zu prächtigen Monumenten bis hin zu spannenden Museen und vielen weiteren Aktivitäten.</p>",
    "textInfo" : {
      "situation" : "<p>Mitten im Stadtzentrum und nur etwa 100 m vom Hauptbahnhof Helsinki entfernt. Diverse Bars, Restaurants und Einkaufsmöglichkeiten befinden sich in nächster Nähe. In etwa 800 m erreichen Sie den malerischen Botanischen Garten. Bis zum Flughafen Helsinki-Vantaa brauchen Sie ungefähr 19 km.</p>",
      "facilityFeatures" : "<p>Das Holiday Inn Helsinki City Centre begrüsst Sie in einer einladenden Empfangshalle mit Réception und WLAN (gratis). Für das leibliche Wohl sorgt das internationale Hauptrestaurant mit A-la-carte oder Buffetoption. Zur Entspannung stehen ein Café und eine Bar für Sie bereit. Statten Sie einen Besuch auf der Terrasse oder im Unterhaltungsraum ab und verbringen Sie dort Zeit mit Ihren Liebsten.</p>",
      "accommodationFeatures" : "<p>Die geräumigen <b>Zimmer </b>verfügen über Dusche oder Bad, WC, Bademantel und Hausschuhe, Föhn; Telefon, TV, WLAN (gratis), Tee-/Kaffeekocher, Klimaanlage.</p>",
      "rooms" : "174",
      "sportFree" : "<p>Fitnessraum. <b>Wellness</b>: Spa mit Sauna.</p>",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : false,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : false,
        "inRoomFreeWifi" : false,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : false,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : true,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : true,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : true,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : false,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : true,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755783.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755783.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755733.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755820.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755737.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755735.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755741.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755738.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755815.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755812.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755831.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755769.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755740.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755828.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755792.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755757.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755826.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755814.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-38114",
    "giataCode" : 38114,
    "name" : "Hilton Helsinki Strand",
    "rating" : 5.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.1772638,
      "longitude" : 24.9518575
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Gemütliche Spaziergänge, alte wie auch moderne Kunst, strahlende Parks und Geschichten aus vergangenen Zeiten – die felsige Landzunge mit Blick auf die Ostsee wird Sie nicht enttäuschen. </p>",
    "textInfo" : {
      "situation" : "<p>Direkt am Kanal der kulturreichen Hauptstadt Helsinki. Nur eine Brücke und ca. 500 m vom malerischen Botanischen Garten Kaisaniemi entfernt. Die nächstgelegene Strassenbahnstation erreichen Sie in rund 350 m. Das Stadtzentrum mit diversen Bars, Restaurants, Einkaufsmöglichkeiten und der imposanten evangelischen Kirche «Dom zu Helsinki» befindet sich in ungefähr 900 m. An den Hauptbahnhof Helsinki gelangen Sie in etwa 1 km, zum Flughafen Helsinki-Vantaa brauchen Sie knapp 18 km.</p>",
      "facilityFeatures" : "<p>Das Hilton Helsinki Strand begrüsst Sie in einer einladenden Empfangshalle mit Réception und WLAN (gratis). Für das kulinarische Wohl wartet das Hauptrestaurant mit italienischer Küche auf Sie, zur Erfrischung steht eine Bar für Sie bereit.</p>",
      "accommodationFeatures" : "<p>Die gemütlichen <b>Zimmer </b>verfügen über Dusche, WC, Föhn; Telefon, TV, WLAN (gratis), Safe, Minibar, Klimaanlage; buchbar mit Bettsofa, Stadt- oder Meerblick. Die <b>Suiten </b>sind bei gleicher Ausstattung geräumiger und verfügen zusätzlich über Bettsofa, Bademantel und Hausschuhe, buchbar mit Balkon; Meer- oder Kanalblick.</p>",
      "rooms" : "190",
      "sportFree" : "<p>Fitnessraum. <b>Wellness</b>: Hallenbad.</p>",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>*****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : false,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : true,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : true
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : false,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : true,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758254.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758254.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758267.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758282.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758275.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758276.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758257.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758332.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758260.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758263.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758256.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758292.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758278.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758295.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758298.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758316.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758327.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758345.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/758/758342.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-21205",
    "giataCode" : 21205,
    "name" : "Scandic Simonkenttä",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.168942014166866,
      "longitude" : 24.935254338623054
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Das moderne Stadthotel im Herzen Helsinkis punktet mit stilvoller Einrichtung in angenehmem Ambiente und glänzt mit seinem atemberaubenden Blick von der Dachterrasse.</p>",
    "textInfo" : {
      "situation" : "<p>An zentraler Lage, direkt am Narinkkatori-Platz und neben der Kapelle des Schweigens, ist das Hotel umgeben von zahlreichen Restaurants, Bars und Einkaufsmöglichkeiten. Den Boulevard Esplanadi erreichen Sie nach etwa 600 m. Zum Senatsplatz sowie zum Hafen sind es rund 1,2 km. Der Hauptbahnhof ist ca. 400 m entfernt. Die Tramhaltestelle Simonkatu befindet sich vor dem Hotel.</p>",
      "facilityFeatures" : "<p>Das Hotel der Scandic-Kette verfügt über einen grosszügigen Empfangsbereich mit Réception, WLAN (gratis) und Lobbybar. A-la-carte-Restaurant mit Spezialitäten aus der iberischen Küche, Dachterrasse mit Tapas-Bar, Teleskop und herrlichem Blick über Helsinki.</p>",
      "accommodationFeatures" : "<p>Die stilvoll und gemütlich eingerichteten Zimmer verfügen über Dusche, WC, Föhn; Telefon, Sat.-TV, WLAN (gratis), Gratissafe, Minibar, Klimaanlage; teilweise französischer Balkon. Die Suiten bestehen zusätzlich aus einem durch eine Schiebetür abgetrennten Wohn-/Schlafbereich mit Bettsofa sowie ein zweites Badezimmer und bieten neben der Grundausstattung Bademäntel, Hausschuhe, Tee-/Kaffeekocher und eine Privatsauna; Balkon.</p>",
      "rooms" : "360",
      "sportFree" : "<p>Fitnessraum. <b>Wellness:</b> Sauna.</p>",
      "sportPaid" : "<p>Fahrradverleih.</p>",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : true,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : true,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : true,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567032.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567032.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567059.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567050.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567053.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567061.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567034.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567047.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567026.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567029.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567066.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567037.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567045.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567063.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567056.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567019.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/567/567042.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-21202",
    "giataCode" : 21202,
    "name" : "Marski by Scandic",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.1676354263545,
      "longitude" : 24.941262050997466
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>An bester Lage überzeugt das Viersternehotel durch urbanes Ambiente mit finnischem Touch sowie zuvorkommendem Service. Die perfekte Adresse für Ihren Städtetrip.</p>",
    "textInfo" : {
      "situation" : "<p>Zentral, direkt an der Einkaufsstrasse Mannerheimintie gelegen und gegenüber der Esplanadi, die zum Hafen führt. Restaurants, Bars und zahlreiche Geschäfte befinden sich in nächster Umgebung. Der Senatsplatz ist knapp 800 m entfernt und zur spektakulären Felsenkirche sind es rund 1,1 km. Den Hauptbahnhof erreichen Sie nach ca. 500 m. Die Tramhaltestelle Ylioppilastalo befindet sich vor dem Hotel.</p>",
      "facilityFeatures" : "<p>Das modern und stilvoll eingerichtete Viersternehotel verfügt über einen Empfangsbereich mit Réception und WLAN (gratis). Das innovative A-la-carte-Restaurant bietet finnische Gerichte mit modernem Touch; legendäre Bar, Café. Garage gegen Gebühr.</p>",
      "accommodationFeatures" : "<p>Die einzigartig und zeitlos eingerichteten, komfortablen Zimmer (ohne Fenster) verfügen über Bad oder Dusche, WC, Föhn; Telefon, Sat.-TV, WLAN (gratis), Gratissafe, Minibar, Tee-/Kaffeekocher, Klimaanlage. Zimmerservice. Auch mit Fenster buchbar.</p>",
      "rooms" : "289",
      "sportFree" : "<p>Fitnessraum. <b>Wellness: </b>Sauna.</p>",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "<p>Frühstück.</p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/544/544143.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/544/544143.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/544/544140.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/544/544149.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/544/544147.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/544/544142.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/544/544148.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/544/544146.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/544/544141.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/544/544150.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/544/544145.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/544/544144.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-539714",
    "giataCode" : 539714,
    "name" : "Clarion Hotel Helsinki",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.15963102193709,
      "longitude" : 24.921978591802983
    },
    "mapZoom" : 15,
    "mythosInfo" : null,
    "leadText" : "<p>Das moderne Hotel hebt sich von der Masse ab. Mit seinen zwei 16-stöckigen Türmen ist das Clarion Hotel Helsinki ein beeindruckendes Wahrzeichen und ein lebendiger Treffpunkt der Stadt. </p>",
    "textInfo" : {
      "situation" : "<p>Das Clarion Hotel Helsinki liegt im farbenfrohen und urbanen Viertel Jätkäsaari (Busholmen) im zentralen Westhafengebiet. Einige Restaurants und Geschäfte befinden sich in unmittelbarer Nähe. Das Stadtzentrum erreichen Sie nach etwa 1,5 km. Die Bushaltestelle Huutokonttori befindet sich direkt neben dem Hotel. Zum Hauptbahnhof sind es ca. 2 km. </p>",
      "facilityFeatures" : "<p>Die gemütliche Lobby mit Réception und WLAN (gratis) ist ein beliebter Treffpunkt für Hotelgäste und Einheimische. Zu den gastronomischen Angeboten zählen ein internationales A-la-carte-Restaurant und eine Skyroom-Bar mit Blick über die Dächer der Stadt. Die Dachterrasse mit Pool (heizbar) bietet eine spektakuläre Aussicht über Helsinki.</p>",
      "accommodationFeatures" : "<p>Geräumige, im finnisch-europäischen Design eingerichtete <b>Zimmer</b> (16–20 m<sup>2</sup>) mit Bad oder Dusche, WC, Föhn; Telefon, TV, WLAN (gratis), Gratissafe, Minibar. Die <b>Superior-Zimmer</b> (20–22 m<sup>2</sup>) verfügen zusätzlich über Bademäntel und Hausschuhe. Auch in den obersten Etagen buchbar. Die <b>Deluxe-Zimmer</b> (ca. 30m<sup>2</sup>) bieten zusätzlich einen Tee–/Kaffeekocher. Die <b>Junior Suiten</b> (ca. 55m<sup>2</sup>) liegen in den obersten Etagen und verfügen zusätzlich über einen separaten Wohnraum sowie ein separates WC. Zimmerservice.</p>",
      "rooms" : "425",
      "sportFree" : "<p>Fitnessraum. <b>Wellness: </b>Sauna.</p>",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "<p>Frühstück.</p>",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : true,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766311.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766311.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766318.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766299.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766278.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766303.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766279.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766284.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766309.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766300.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766315.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766291.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766289.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766292.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/766/766316.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-76245",
    "giataCode" : 76245,
    "name" : "Holiday Inn Helsinki West Ruoholahti",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.1653727715613,
      "longitude" : 24.9099200965065
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Imposante Monumente, breite Strassen, wunderschöne Kulissen mit strahlenden Parks und grüne Strassenbahnen, die gemächlich durch die Stadt fahren. Lernen Sie die grosse, auf Inseln verteilte Metropole kennen und geniessen Sie die zentrale Lage.</p>",
    "textInfo" : {
      "situation" : "<p>Im geschäftigen Viertel Ruoholahti, mit diversen Restaurants, Bars und Einkaufsmöglichkeiten, wie zum Beispiel das beliebte, circa 600 m entfernte Einkaufszentrum Ruoholahti. Die nächstgelegene Bahnstation «Länsiväylä» erreichen Sie in rund 120 m. Die U-Bahnstation «Ruoholahti» befindet sich in 450 m. Bis ins Zentrum von Helsinki mit etlichen Bars, Restaurants, Einkaufsmöglichkeiten, historischen Gebäuden als auch malerischen kleinen und grossen Parks brauchen Sie ungefähr 2 km. Der Hauptbahnhof Helsinki befindet sich in etwa 3 km, der Flughafen Helsinki-Vantaa in circa 20 km.</p>",
      "facilityFeatures" : "<p>Das Holiday Inn Helsinki West Ruoholahti begrüsst Sie in einer einladenden Empfangshalle mit Réception und WLAN (gratis). Für das kulinarische Wohl steht das Hauptrestaurant mit internationaler Küche für Sie bereit. Zur Erfrischung warten ein Café und eine Bar auf Sie. Statten Sie einen Besuch im Spiel- und Entspannungsraum ab und geniessen Sie die Zeit mit Freunden oder Familie.</p>",
      "accommodationFeatures" : "<p>Die geräumigen <b>Zimmer </b>verfügen über Dusche, WC, Bademantel und Hausschuhe, Föhn; Telefon, TV, WLAN (gratis), Safe, Minibar, Tee-/Kaffeekocher, Klimaanlage, buchbar mit Bettsofa; Meersicht.</p>",
      "rooms" : "256",
      "sportFree" : "<p>Fitnessraum.</p>",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "<p>Spielecke.</p>",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : false,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : true,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : true,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : false,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : true,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755638.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755638.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755637.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755633.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755632.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755634.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755642.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755635.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755647.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755640.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755655.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755683.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755641.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/755/755650.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-19813",
    "giataCode" : 19813,
    "name" : "Radisson Blu Royal Hotel Helsinki",
    "rating" : 4.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.167760850557,
      "longitude" : 24.9300527852029
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Entdecken Sie die breiten Strassen Helsinkis mit den hohen, imposanten Häusern und zierlichen, bunten Strassenbahnen.</p>",
    "textInfo" : {
      "situation" : "<p>Mitten im Stadtzentrum, mit diversen Bars, Restaurants und Einkaufsmöglichkeiten in nächster Nähe. Die nächste Strassenbahnstation «Kampintori» befindet sich in ca. 220 m. Bis zum Hauptbahnhof Helsinki brauchen Sie etwa 1 km. Den Flughafen Helsinki-Vantaa erreichen Sie in rund 19 km.</p>",
      "facilityFeatures" : "<p>Das Radisson Blu Royal Hotel Helsinki begrüsst Sie in einer grossen Empfangshalle mit Réception und WLAN (gratis). Für das kulinarische Wohl und zur Erfrischung warten das internationale Hauptrestaurant und ein tägliches Frühstücksbuffet.</p>",
      "accommodationFeatures" : "<p>Die hellen <b>Zimmer </b>verfügen über Dusche, WC, Föhn; Telefon, TV, WLAN (gratis), Minibar, Safe, buchbar mit Nespresso-Maschine, Klimaanlage. Die <b>Suiten</b> verfügen über dieselbe Grundausstattung, dazu extra Wohnraum mit Bettsofa.</p>",
      "rooms" : "262",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : true,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : false,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : true,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754234.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754234.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754263.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754243.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754210.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754195.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754219.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754185.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754280.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754254.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754267.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754189.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754216.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754276.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754207.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754242.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754240.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/754/754182.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-11031",
    "giataCode" : 11031,
    "name" : "Scandic Kaisaniemi",
    "rating" : 3.0,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.171684,
      "longitude" : 24.94800699999996
    },
    "mapZoom" : 20,
    "mythosInfo" : null,
    "leadText" : "<p>Beliebtes, einfaches Mittelklassehotel mit idealer Lage für Städte- oder Durchreisende dank der Nähe zum Hauptbahnhof.</p>",
    "textInfo" : {
      "situation" : "<p>An zentraler Lage, ca. 350 m vom Hauptbahnhof entfernt. Das Finnische Nationaltheater, das Kunstmuseum Ateneum und ein Kinokomplex befinden sich in unmittelbarer Nähe. Die vielen Einkaufsmöglichkeiten erreichen Sie in wenigen Gehminuten.</p>",
      "facilityFeatures" : "<p>Frühstücksraum mit gemütlicher Atmosphäre. Getränke erhalten Sie an der Lobbybar. Zudem verfügt das Hotel über eine Sauna (gegen Gebühr).</p>",
      "accommodationFeatures" : "<p>Die Standard-Zimmer haben unterschiedliche Grössen und bieten entweder separate Betten oder 140–160 cm breite Doppelbetten. Alle Zimmer sind mit Dusche, WC, Föhn, TV, Radio und einem Safe ausgerüstet. WLAN (gratis). Einige Superior-Zimmer verfügen zusätzlich über eine eigene Sauna, Bügeleisen und Minibar.</p>",
      "rooms" : "123",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>***</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : true,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : false,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : false,
        "snackBarBistro" : false,
        "roomService" : false
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : false,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : true,
        "rooms500" : false,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/404/404443.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/404/404443.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/404/404447.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/404/404444.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/404/404446.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/404/404445.jpg"
    }, {
      "url" : "https://assets.hotelplan.com/myassets/webimages/404/404448.jpg"
    } ]
  }, {
    "__typename" : "FdrHotel",
    "publicId" : "h-35482",
    "giataCode" : 35482,
    "name" : "Radisson Blu Plaza Helsinki",
    "rating" : 4.5,
    "tripAdvisorCode" : 0,
    "coordinates" : {
      "latitude" : 60.172491928761,
      "longitude" : 24.945305585861
    },
    "mapZoom" : 14,
    "mythosInfo" : null,
    "leadText" : "<p>Dieses Erstklasshotel bietet hohen Wohnkomfort und aufmerksamen Service. Alte, denkmalgeschützte Räume wurden gekonnt mit modernen Elementen kombiniert.</p>",
    "textInfo" : {
      "situation" : "<p>Die zentrale Lage macht das Hotel zu einem idealen Ausgangspunkt, um Helsinki zu Fuss zu erkunden. Den Hauptbhanhof von Helsinki erreicht man in wenigen Gehschritten, verschiedenste Sehenswürdigkeiten und Einkaufszentren sind in wenigen Gehminuten erreichbar.</p>",
      "facilityFeatures" : "<p>Neben dem gemütlichen Empfangsraum befindet sich das bekannte Kitzens-Restaurant und bietet eine internationale Speisekarte mit vielen Leckerbissen. Sie können sich aber auch Ihr eigenes Menue zusammenstellen. Die Bar 7 Blings ist ein Ort wo man gerne einen Drink und das Ambiente geniesst. Das Plaza H.U.B. serviert rund um die Uhr Snacks und Drinks. Für die sportliche Betätigung bietet sich der kleine Fitnessraum im 2. Stock an, aber auch die zwei nahe gelegenen Parks bieten sich für eine Joggingrunde an. WLAN ist für alle Gäste gratis zugänglich. Parkplätze sind gegen Gebühr erhältlich.</p>",
      "accommodationFeatures" : "<p>Die 302 grosszügigen Zimmer wurden alle im Jahr 2012 umfassend renoviert und verfügen über komfortable Betten, Bad oder Dusche, WC, Föhn, Telefon, Minibar und Hosenpresse. Die Business Class Zimmer haben zusätzlich ein Kaffeemaschine und einem zusätzlichen TV im Bad.</p>",
      "rooms" : "291",
      "sportFree" : "",
      "sportPaid" : "",
      "activities" : "",
      "forKids" : "",
      "catering" : "",
      "hints" : "",
      "infoPlus" : "",
      "familyHits" : "",
      "skiPackages" : "",
      "wellnessPlus" : "",
      "hotelWellnessInfo" : "",
      "hotelWellnessPaket" : "",
      "moreInformation" : "",
      "officialRating" : "<p>*****</p>",
      "highlights" : ""
    },
    "flags" : {
      "top" : false,
      "bestseller" : false,
      "cityTrip" : true,
      "winterSport" : false,
      "summerSport" : false,
      "nightLife" : true,
      "gourmet" : false,
      "club" : false,
      "luxury" : false,
      "pets" : false,
      "sustainable" : false,
      "romantic" : false,
      "gayLesbians" : false,
      "ski" : false,
      "funPark" : false,
      "nationalPark" : false,
      "adultsOnly" : false,
      "refundable" : false,
      "extraOrdinary" : false,
      "wifi" : {
        "achieved" : true,
        "inRoomFreeWifi" : true,
        "inRoomPaidWifi" : false,
        "inLobbyFreeWifi" : true,
        "inLobbyPaidWifi" : false
      },
      "beach" : {
        "achieved" : false,
        "sandyBeach" : false,
        "sandyBeachWhiteFine" : false,
        "cobbleStone" : false,
        "rocksStones" : false,
        "naturalBeach" : false,
        "gentlySloping" : false,
        "privateBeach" : false,
        "reefBeach" : false
      },
      "foodAndBeverage" : {
        "buffet" : false,
        "alaCarteRestaurants" : true,
        "gourmetRestaurant" : false,
        "beachBar" : false,
        "bar" : true,
        "snackBarBistro" : true,
        "roomService" : true
      },
      "entertainment" : {
        "achieved" : false,
        "discoNightclub" : false,
        "animation" : false,
        "show" : false
      },
      "beautyAndWellness" : {
        "achieved" : false,
        "sauna" : true,
        "steamBathHamam" : false,
        "spaHealthCenter" : false,
        "massage" : false,
        "ayurveda" : false,
        "beautyTreatment" : false,
        "yoga" : false
      },
      "waterSport" : {
        "achieved" : false,
        "diveCenter" : false,
        "canoeKayak" : false,
        "sailingCatamaran" : false,
        "waterSkiWakeboarding" : false,
        "surfing" : false,
        "windSurfing" : false,
        "kiteSurfing" : false,
        "outdoorPool" : false,
        "indoorPool" : false
      },
      "sport" : {
        "achieved" : false,
        "gym" : false,
        "soccer" : false,
        "beachSport" : false,
        "tennis" : false,
        "golfDrivingRange" : false,
        "cycling" : false,
        "sportProgram" : false,
        "squash" : false,
        "skiPackageAvailable" : false
      },
      "location" : {
        "beachFront" : false,
        "distanceToBeach500M" : false,
        "directlyAtSlopeValleyStation" : false,
        "distanceToSlopeValleyStation300M" : false,
        "cityCenter" : true,
        "ruralArea" : false,
        "remoteArea" : false,
        "directlyAtSea" : false,
        "nationalPark" : false,
        "airportHotel" : false,
        "directlyAtLake" : false
      },
      "family" : {
        "achieved" : false,
        "babysittingService" : false,
        "childCare" : false,
        "miniOrChildrenClub" : false,
        "teenProgram" : false,
        "childPool" : false,
        "childrenPlayground" : false,
        "waterSlide" : false
      },
      "customerSegment" : {
        "honeymooner" : false,
        "singles" : false,
        "couples" : false,
        "gayLesbians" : false,
        "adultsOnly" : false
      },
      "typeFlags" : {
        "rooms50" : false,
        "rooms100" : false,
        "rooms200" : false,
        "rooms500" : true,
        "rooms999" : false,
        "modernDesign" : false,
        "luxury" : false,
        "charm" : false,
        "funPark" : false,
        "familyAtmosphere" : false,
        "club" : false,
        "wheelchairAccess" : false,
        "sustainable" : false,
        "petsWelcome" : false,
        "parking" : false,
        "apartment" : false,
        "chargingStations" : false
      }
    },
    "hero" : {
      "url" : "https://assets.hotelplan.com/myassets/webimages/076/076079.jpg"
    },
    "images" : [ {
      "url" : "https://assets.hotelplan.com/myassets/webimages/076/076079.jpg"
    } ]
  }
];
